import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Paper,
  Typography,
  Button,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  Divider,
  Tabs,
  Tab,
  TableContainer,
  IconButton,
  Chip,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SendIcon from "@mui/icons-material/Send";
import MedicationIcon from "@mui/icons-material/Medication";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import UndoIcon from "@mui/icons-material/Undo";
import { useTheme } from "@mui/material";
import { tokens } from "../../theme";
import { useParams, useNavigate, useLocation, useSearchParams } from "react-router-dom";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { getByAdmissionId } from "../../services/PatientConsumablesService";
import { getVisitsByAdmission } from "../../services/DoctorVisitService";
import { getAssignmentByAdmissionId } from "../../services/PatientAssignmentService";
import { getByAdmission } from "../../services/PatientOperationService";
import { getTreatmentsByAdmissionId } from "../../services/PatientTreatmentService";
import { getDischargesByAdmissionId } from "../../services/DischargeService";
import { getPatientById } from "../../services/patientService";
import { getIpdPrescriptionsByPatientId } from "../../services/ipdPrescriptionService";
import {
  getAdmissionByPatientId,
  getAll as getAllAdmissions,
} from "../../services/PatientAdmissionService";
import { getMedicineList } from "../../services/medicineService";
import { getLabTestsByAdmissionId } from "../../services/PatientlabTestService";
import { getDoctorById } from "../../services/doctorService";
import { getAllLabTests } from "../../services/labtestService";
import { hasSubCategories } from "../PathManagePatient/labTestWorkflowUtils";
import { getStaffByUserId, getAllStaff } from "../../services/StaffService";
import { getAllWards } from "../../services/WardService";
import { getAllBeds } from "../../services/BedService";
import PatientAssignmentModal from "../inPatientDetail/patientAssignment.jsx";
import PatientTreatmentModal from "../inPatientDetail/patientTreatments.jsx";
import PatientConsumableModal from "../inPatientDetail/patientConsumables.jsx";
import DoctorVisitsModal from "../inPatientDetail/doctorVisits.jsx";
import PatientOperationModal from "../inPatientDetail/patientOperations.jsx";
import PatientDischargeModal from "../inPatientDetail/patientDischarge.jsx";
import IpdInvoice from "../inPatientDetail/IpdInvoice.jsx";
import Header from "../../components/Header";
import { useAuth } from "../../context/AuthContext";
import {
  filterByOrganization,
  getOrganizationName,
  getOrganizationId,
} from "../../utils/organizationUtils";
import {
  buildIpdSummaryDocumentHtml,
  exportPatientSummaryDocumentToPdf,
  getPatientPdfFilename,
  printPatientSummaryDocument,
} from "../../utils/patientSummaryDocumentUtils";
import { toPeriodDateKey } from "../../utils/patientPeriodSummary";
import {
  displayId,
  formatAdmissionDateTime,
  resolveAdmissionPrescriptionId,
  resolveTimelineFocusTab,
  getDefaultIpdTimelineTabIndex,
} from "../../utils/patientTimelineVisitUtils";
import PatientTimelinePrintMenu from "../../components/PatientTimelinePrintMenu";
import { getHistoryByPatientAndAdmission } from "../../services/KardexMedicalHistoryService";
import { getByPatientAndAdmission } from "../../services/KardexVitalSignsService";
import { getNutritionByPatientAndAdmission } from "../../services/KardexDietPlansService";
import { getEliminationByAdmissionId } from "../../services/KardexEliminationService";
import { getInvestigationByPatientAndAdmission } from "../../services/KardexInvestigationService";
import { getNursingByAdmissionId } from "../../services/KardexNursingCareService";
import { getProceduresByAdmissionId } from "../../services/KardexDeviceService";
import { getMobilityByPatientAndAdmission } from "../../services/KardexMobilityService";
import { getNotesByPatientAndAdmission } from "../../services/KardexNurseNotesService";
import { getCommunicationByPatientAndAdmission } from "../../services/KardexPatientCommunicationService";
import { getMiscByAdmission } from "../../services/KardexMiscAlertsService";
import { getMedicationsByPatientAndAdmission } from "../../services/KardexMedicationsService";
import { getFluidsByAdmissionId } from "../../services/KardexIvFluidsService";
import { getAdministrationHistory } from "../../services/patientMedicineInventoryService";
import {
  createMedicineRequest,
  getRequestsByAdmissionId,
  receiveMedicineRequest,
  dispenseMedicineRequest,
  returnMedicineRequest,
} from "../../services/medicineRequestService";
import {
  getByAdmissionId as getPatientMedicineInventory,
  administerToPatient,
  returnToPharmacy as returnPatientMedicineToPharmacy,
} from "../../services/patientMedicineInventoryService";
import MedicineRequestModal from "../inventory/Pharmacy/MedicineRequestModal";
import MedicineReturnModal from "../inventory/Pharmacy/MedicineReturnModal";
import PatientMedicineAdministrationModal from "../inventory/Pharmacy/PatientMedicineAdministrationModal";
import IpdIssueMedicineModal from "../inventory/Pharmacy/IpdIssueMedicineModal";

const applyDynamicPageBreaks = () => {
 const sections = document.querySelectorAll(".table-section");

  const A4_HEIGHT_PX = 1122;
  const HEADER_SPACE = 150;

  sections.forEach((section) => {
    const rect = section.getBoundingClientRect();

    const top = rect.top + window.scrollY;
    const height = rect.height;

    const positionInPage = (top - HEADER_SPACE) % A4_HEIGHT_PX;
    const remainingSpace = A4_HEIGHT_PX - positionInPage;

    if (height > remainingSpace) {
      section.style.pageBreakBefore = "always";
      section.style.breakBefore = "page";
    }
  });
};

const resetPageBreaks = () => {
  const sections = document.querySelectorAll(".pdf-section");
  sections.forEach((section) => {
    section.style.pageBreakBefore = "auto";
    section.style.breakBefore = "auto";
  });
};

dayjs.extend(utc);
dayjs.extend(timezone);

const tabLabels = [
  "Admisson Details",
  "Assignments",
  "Medicines",
  "Lab Tests",
  "Operations",
  "Consumables",
  "Visit Records",
  "Nurse Notes",
  "Discharge Details",
  "IPD Summary",
];

const PatientTimeline = (props) => {
  const { patientId: routePatientId } = useParams();
  const patientId = props?.patientId ?? routePatientId;
  const onBack = props?.onBack;
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const theme = useTheme();
  const reportRef = useRef();
  const { user } = useAuth();
  const normalizedRole = String(user?.roleName || user?.role || "").toLowerCase();
  const isPharmacyAdmin = normalizedRole === "pharmacy admin";
  const timelineFocusTab = resolveTimelineFocusTab({
    propTab: props?.timelineTab,
    locationState: location?.state,
    searchParams,
  });
  const defaultTimelineTabIndex = getDefaultIpdTimelineTabIndex(timelineFocusTab, {
    isPharmacyAdmin,
  });
  const colors = tokens(theme.palette.mode);
  const primaryColor = theme.palette.primary.main || "#1976d2";
  const [anchorEl, setAnchorEl] = useState(null);
  const [activeTabs, setActiveTabs] = useState({});
  const [consumableList, setConsumableList] = useState([]);
  const [visitList, setVisitList] = useState([]);
  const [AssignmentList, setAssignmentList] = useState([]);
  const [operationList, setOperationList] = useState([]);
  const [treatmentList, setTreatmentList] = useState([]);
  const [dischargeList, setDischargeList] = useState([]);
  const [patientInfo, setPatientInfo] = useState({});
  const [AdmissionList, setAdmissionList] = useState([]);
  const [ipdPrescriptionList, setIpdPrescriptionList] = useState({});
  const [LabtTestList, setLabTestList] = useState([]);
  const [medicine_list, setMedicine] = useState([]);
  const [menuAnchorEls, setMenuAnchorEls] = useState({});
  const [open_doctor_modal, setOpenDoctorModal] = useState(false);
  const [open_treatment_modal, setOpenTreatmentModal] = useState(false);
  const [open_assignment_modal, setOpenAsignmentModal] = useState(false);
  const [open_consumable_modal, setOpenConsumableModal] = useState(false);
  const [open_doctorVisit_modal, setOpenDoctorvisitModal] = useState(false);
  const [open_operation_modal, setOpenOperationModal] = useState(false);
  const [open_discharge_modal, setOpenDischargeModal] = useState(false);
  const [open_invoice_modal, setOpenInvoiceModal] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [selectedAdmissionId, setSelectedAdmissionId] = useState(null);
  const [selectedPatientId, setSelectedPatientId] = useState(null);
  const [refreshFlag, setRefreshFlag] = useState(false);
  const [HistoryList, setHistoryList] = useState([]);
  const [vitalList, setVitalList] = useState([]);
  const [nutritionList, setNutritionList] = useState([]);
  const [eliminationList, setEliminationList] = useState([]);
  const [investigationList, setInvestigationList] = useState([]);
  const [careList, setCareList] = useState([]);
  const [procedureList, setProcedureList] = useState([]);
  const [mobilityList, setMobilityList] = useState([]);
  const [notesList, setNotesList] = useState([]);
  const [communicationList, setCommunicationList] = useState([]);
  const [miscAlertList, setMiscAlertList] = useState([]);
  const [medicationListList, setMedicationList] = useState([]);
  const [FluidList, setFluidList] = useState([]);

  // Medicine Request Workflow States
  const [medicineRequests, setMedicineRequests] = useState({});
  const [openRequestModal, setOpenRequestModal] = useState(false);
  const [selectedRequestTreatment, setSelectedRequestTreatment] =
    useState(null);
  const [openReturnModal, setOpenReturnModal] = useState(false);
  const [selectedReturnTreatment, setSelectedReturnTreatment] = useState(null);
  const [openIssueMedicineModal, setOpenIssueMedicineModal] = useState(false);
  const [selectedIssueTreatment, setSelectedIssueTreatment] = useState(null);

  // Patient Medicine Inventory States
  const [patientMedicineInventory, setPatientMedicineInventory] = useState({});
  const [openAdministrationModal, setOpenAdministrationModal] = useState(false);
  const [selectedInventoryItem, setSelectedInventoryItem] = useState(null);

  // Current staff ID (from staff table, not user table)
  const [currentStaffId, setCurrentStaffId] = useState(null);
  // Lookup maps for enriching assignments (staff, ward, bed)
  const [staffLookup, setStaffLookup] = useState(null);
  const [wardLookup, setWardLookup] = useState(null);
  const [bedLookup, setBedLookup] = useState(null);

  // Hospital/Organization info for print and PDF
  const [hospitalName, setHospitalName] = useState("ARYAN HOSPITAL");
  const [hospitalAddress, setHospitalAddress] = useState(
    "123 Medical Street, Health City",
  );
  const [hospitalPhone, setHospitalPhone] = useState("");
  const formatDate = (arr) => {
    if (!Array.isArray(arr)) return "-";
    const [y, m, d] = arr;
    return dayjs(new Date(y, m - 1, d)).format("DD MMM YYYY");
  };

  const formatTime = (arr) => {
    if (!Array.isArray(arr)) return "-";
    const [y, m, d, h = 0, min = 0, s = 0] = arr;
    return dayjs(new Date(y, m - 1, d, h, min, s)).format("hh:mm A");
  };
  useEffect(() => {
    // Ensure lookup data (staff, ward, bed) is loaded BEFORE fetching admissions,
    // so that assignments can be enriched with nurseName, wardName, and bedName.
    (async () => {
      try {
        // Load lookup data first and wait for it to complete
        await loadLookupData();
      } catch (e) {
        // Non-critical; assignments will still load but without enriched names
        console.error("Error preloading lookup data:", e);
      }

      // These can safely run after lookup loading
      fetchPatientDetails();
      fetchPatientAdmission();
      fetchMedicine();
      fetchCurrentStaffId();
      fetchHospitalInfo(); // Fetch hospital info for print/PDF
    })();
  }, [refreshFlag]);

  // Fetch current staff ID if user is staff/nurse
  const fetchCurrentStaffId = async () => {
    if (user && (user.roleName === "staff" || user.roleName === "nurse")) {
      try {
        const staffDetails = await getStaffByUserId(user.id);
        setCurrentStaffId(staffDetails.id);
      } catch (error) {
        console.error("Failed to fetch staff ID:", error);
      }
    }
  };

  // Load lookup data for staff, wards, and beds (used to enrich assignments)
  const loadLookupData = async () => {
    try {
      const [staff, wards, beds] = await Promise.all([
        getAllStaff().catch(() => []),
        getAllWards().catch(() => []),
        getAllBeds().catch(() => []),
      ]);

      // Filter by organization as defensive measure (backend should already filter via organizationId query param)
      const filteredStaff = filterByOrganization(staff || [], user);
      const filteredWards = filterByOrganization(wards || [], user);
      const filteredBeds = filterByOrganization(beds || [], user);

      if (Array.isArray(filteredStaff) && filteredStaff.length) {
        const map = new Map();
        filteredStaff.forEach((s) => {
          if (s && s.id != null) {
            const staffName = s.name || s.fullName || s.username || "";
            // Index by staff.id (for assignments, treatments, etc.) - store both String and Number keys
            map.set(String(s.id), staffName);
            map.set(Number(s.id), staffName);
            // Also index by staff.userId (for lab tests where labId refers to userId)
            if (s.userId != null) {
              map.set(String(s.userId), staffName);
              map.set(Number(s.userId), staffName);
            }
          }
        });
        setStaffLookup(map);
      } else {
        setStaffLookup(new Map()); // Initialize empty map if no data
      }

      if (Array.isArray(filteredWards) && filteredWards.length) {
        const map = new Map();
        filteredWards.forEach((w) => {
          if (w && w.id != null) {
            const wardName = w.name || w.wardName || w.ward || "";
            // Store both Number and String keys for flexible lookup
            map.set(Number(w.id), wardName);
            map.set(String(w.id), wardName);
          }
        });
        setWardLookup(map);
      } else {
        setWardLookup(new Map()); // Initialize empty map if no data
      }

      if (Array.isArray(filteredBeds) && filteredBeds.length) {
        const map = new Map();
        filteredBeds.forEach((b) => {
          if (b && b.id != null) {
            const bedName = b.bedNumber || b.name || b.bed || "";
            // Store both Number and String keys for flexible lookup
            map.set(Number(b.id), bedName);
            map.set(String(b.id), bedName);
          }
        });
        setBedLookup(map);
      } else {
        setBedLookup(new Map()); // Initialize empty map if no data
      }
    } catch (e) {
      // Lookup data is non-critical; log and continue
      console.error("Failed to load lookup data for assignments:", e);
      // Initialize empty maps on error
      setStaffLookup(new Map());
      setWardLookup(new Map());
      setBedLookup(new Map());
    }
  };

  const fetchKardexMedicalHistory = async (admissions) => {
    try {
      const historyResults = {};

      // Reload staff lookup data to ensure we have the latest data
      let currentStaffLookup;
      try {
        const staff = await getAllStaff().catch(() => []);
        const filteredStaff = filterByOrganization(staff || [], user);
        currentStaffLookup = new Map();
        if (Array.isArray(filteredStaff) && filteredStaff.length) {
          filteredStaff.forEach((s) => {
            if (s && s.id != null) {
              const staffName = s.name || s.fullName || s.username || "";
              currentStaffLookup.set(String(s.id), staffName);
              currentStaffLookup.set(Number(s.id), staffName);
              if (s.userId != null) {
                currentStaffLookup.set(String(s.userId), staffName);
                currentStaffLookup.set(Number(s.userId), staffName);
              }
            }
          });
        }
      } catch (lookupError) {
        currentStaffLookup =
          staffLookup instanceof Map ? staffLookup : new Map();
      }

      await Promise.all(
        admissions.map(async (admission) => {
          let medicalHistory = await getHistoryByPatientAndAdmission(
            patientId,
            admission.id,
          );

          // Apply organization filter defensively
          medicalHistory = filterByOrganization(
            Array.isArray(medicalHistory)
              ? medicalHistory
              : medicalHistory
              ? [medicalHistory]
              : [],
            user,
          );

          // Enrich with nurseName from staff lookup
          if (Array.isArray(medicalHistory) && medicalHistory.length > 0) {
            medicalHistory = medicalHistory.map((history) => {
              const enriched = { ...history };
              if (enriched.nurseId && currentStaffLookup.size > 0) {
                const staffId = String(enriched.nurseId);
                const staffName =
                  currentStaffLookup.get(staffId) ||
                  currentStaffLookup.get(Number(enriched.nurseId));
                if (staffName) enriched.nurseName = staffName;
              }
              return enriched;
            });
          }

          historyResults[admission.id] = medicalHistory;
        }),
      );
      setHistoryList(historyResults);
    } catch (error) {
      console.error("Failed to fetch medical history", error);
    }
  };

  const fetchKardexVitalSigns = async (admissions) => {
    try {
      const vitalResults = {};

      // Reload staff lookup data to ensure we have the latest data
      let currentStaffLookup;
      try {
        const staff = await getAllStaff().catch(() => []);
        const filteredStaff = filterByOrganization(staff || [], user);
        currentStaffLookup = new Map();
        if (Array.isArray(filteredStaff) && filteredStaff.length) {
          filteredStaff.forEach((s) => {
            if (s && s.id != null) {
              const staffName = s.name || s.fullName || s.username || "";
              currentStaffLookup.set(String(s.id), staffName);
              currentStaffLookup.set(Number(s.id), staffName);
              if (s.userId != null) {
                currentStaffLookup.set(String(s.userId), staffName);
                currentStaffLookup.set(Number(s.userId), staffName);
              }
            }
          });
        }
      } catch (lookupError) {
        currentStaffLookup =
          staffLookup instanceof Map ? staffLookup : new Map();
      }

      await Promise.all(
        admissions.map(async (admission) => {
          let vitalHistory = await getByPatientAndAdmission(
            patientId,
            admission.id,
          );

          // Apply organization filter defensively
          vitalHistory = filterByOrganization(
            Array.isArray(vitalHistory)
              ? vitalHistory
              : vitalHistory
              ? [vitalHistory]
              : [],
            user,
          );

          // Enrich with nurseName from staff lookup
          if (Array.isArray(vitalHistory) && vitalHistory.length > 0) {
            vitalHistory = vitalHistory.map((vital) => {
              const enriched = { ...vital };
              if (enriched.nurseId && currentStaffLookup.size > 0) {
                const staffId = String(enriched.nurseId);
                const staffName =
                  currentStaffLookup.get(staffId) ||
                  currentStaffLookup.get(Number(enriched.nurseId));
                if (staffName) enriched.nurseName = staffName;
              }
              return enriched;
            });
          }

          vitalResults[admission.id] = vitalHistory;
        }),
      );
      setVitalList(vitalResults);
    } catch (error) {
      console.error("Failed to fetch vital signs", error);
    }
  };

  const fetchKardexNutritions = async (admissions) => {
    try {
      const nutritionResults = {};

      // Reload staff lookup data to ensure we have the latest data
      let currentStaffLookup;
      try {
        const staff = await getAllStaff().catch(() => []);
        const filteredStaff = filterByOrganization(staff || [], user);
        currentStaffLookup = new Map();
        if (Array.isArray(filteredStaff) && filteredStaff.length) {
          filteredStaff.forEach((s) => {
            if (s && s.id != null) {
              const staffName = s.name || s.fullName || s.username || "";
              currentStaffLookup.set(String(s.id), staffName);
              currentStaffLookup.set(Number(s.id), staffName);
              if (s.userId != null) {
                currentStaffLookup.set(String(s.userId), staffName);
                currentStaffLookup.set(Number(s.userId), staffName);
              }
            }
          });
        }
      } catch (lookupError) {
        currentStaffLookup =
          staffLookup instanceof Map ? staffLookup : new Map();
      }

      await Promise.all(
        admissions.map(async (admission) => {
          let nutritionHistory = await getNutritionByPatientAndAdmission(
            patientId,
            admission.id,
          );

          // Apply organization filter defensively
          nutritionHistory = filterByOrganization(
            Array.isArray(nutritionHistory)
              ? nutritionHistory
              : nutritionHistory
              ? [nutritionHistory]
              : [],
            user,
          );

          // Enrich with nurseName from staff lookup
          if (Array.isArray(nutritionHistory) && nutritionHistory.length > 0) {
            nutritionHistory = nutritionHistory.map((nutrition) => {
              const enriched = { ...nutrition };
              if (enriched.nurseId && currentStaffLookup.size > 0) {
                const staffId = String(enriched.nurseId);
                const staffName =
                  currentStaffLookup.get(staffId) ||
                  currentStaffLookup.get(Number(enriched.nurseId));
                if (staffName) enriched.nurseName = staffName;
              }
              return enriched;
            });
          }

          nutritionResults[admission.id] = nutritionHistory;
        }),
      );
      setNutritionList(nutritionResults);
    } catch (error) {
      console.error("Failed to fetch nutrition", error);
    }
  };

  const fetchKardexElimination = async (admissions) => {
    try {
      const eliminationResults = {};

      // Reload staff lookup data to ensure we have the latest data
      let currentStaffLookup;
      try {
        const staff = await getAllStaff().catch(() => []);
        const filteredStaff = filterByOrganization(staff || [], user);
        currentStaffLookup = new Map();
        if (Array.isArray(filteredStaff) && filteredStaff.length) {
          filteredStaff.forEach((s) => {
            if (s && s.id != null) {
              const staffName = s.name || s.fullName || s.username || "";
              currentStaffLookup.set(String(s.id), staffName);
              currentStaffLookup.set(Number(s.id), staffName);
              if (s.userId != null) {
                currentStaffLookup.set(String(s.userId), staffName);
                currentStaffLookup.set(Number(s.userId), staffName);
              }
            }
          });
        }
      } catch (lookupError) {
        currentStaffLookup =
          staffLookup instanceof Map ? staffLookup : new Map();
      }

      await Promise.all(
        admissions.map(async (admission) => {
          let eliminationHistory = await getEliminationByAdmissionId(
            admission.id,
          );

          // Apply organization filter defensively
          eliminationHistory = filterByOrganization(
            Array.isArray(eliminationHistory)
              ? eliminationHistory
              : eliminationHistory
              ? [eliminationHistory]
              : [],
            user,
          );

          // Enrich with nurseName from staff lookup
          if (
            Array.isArray(eliminationHistory) &&
            eliminationHistory.length > 0
          ) {
            eliminationHistory = eliminationHistory.map((elimination) => {
              const enriched = { ...elimination };
              if (enriched.nurseId && currentStaffLookup.size > 0) {
                const staffId = String(enriched.nurseId);
                const staffName =
                  currentStaffLookup.get(staffId) ||
                  currentStaffLookup.get(Number(enriched.nurseId));
                if (staffName) enriched.nurseName = staffName;
              }
              return enriched;
            });
          }

          eliminationResults[admission.id] = eliminationHistory;
        }),
      );
      setEliminationList(eliminationResults);
    } catch (error) {
      console.error("Failed to fetch elimination", error);
    }
  };

  const fetchKardexInvestigation = async (admissions) => {
    try {
      const investigationResults = {};

      // Reload staff lookup data to ensure we have the latest data
      let currentStaffLookup;
      try {
        const staff = await getAllStaff().catch(() => []);
        const filteredStaff = filterByOrganization(staff || [], user);
        currentStaffLookup = new Map();
        if (Array.isArray(filteredStaff) && filteredStaff.length) {
          filteredStaff.forEach((s) => {
            if (s && s.id != null) {
              const staffName = s.name || s.fullName || s.username || "";
              currentStaffLookup.set(String(s.id), staffName);
              currentStaffLookup.set(Number(s.id), staffName);
              if (s.userId != null) {
                currentStaffLookup.set(String(s.userId), staffName);
                currentStaffLookup.set(Number(s.userId), staffName);
              }
            }
          });
        }
      } catch (lookupError) {
        currentStaffLookup =
          staffLookup instanceof Map ? staffLookup : new Map();
      }

      await Promise.all(
        admissions.map(async (admission) => {
          let investigationHistory =
            await getInvestigationByPatientAndAdmission(
              patientId,
              admission.id,
            );

          // Apply organization filter defensively
          investigationHistory = filterByOrganization(
            Array.isArray(investigationHistory)
              ? investigationHistory
              : investigationHistory
              ? [investigationHistory]
              : [],
            user,
          );

          // Enrich with nurseName from staff lookup
          if (
            Array.isArray(investigationHistory) &&
            investigationHistory.length > 0
          ) {
            investigationHistory = investigationHistory.map((investigation) => {
              const enriched = { ...investigation };
              if (enriched.nurseId && currentStaffLookup.size > 0) {
                const staffId = String(enriched.nurseId);
                const staffName =
                  currentStaffLookup.get(staffId) ||
                  currentStaffLookup.get(Number(enriched.nurseId));
                if (staffName) enriched.nurseName = staffName;
              }
              return enriched;
            });
          }

          investigationResults[admission.id] = investigationHistory;
        }),
      );
      setInvestigationList(investigationResults);
    } catch (error) {
      console.error("Failed to fetch investigation", error);
    }
  };

  const fetchKardexNursingCare = async (admissions) => {
    try {
      const nursingCareResults = {};

      // Reload staff lookup data to ensure we have the latest data
      let currentStaffLookup;
      try {
        const staff = await getAllStaff().catch(() => []);
        const filteredStaff = filterByOrganization(staff || [], user);
        currentStaffLookup = new Map();
        if (Array.isArray(filteredStaff) && filteredStaff.length) {
          filteredStaff.forEach((s) => {
            if (s && s.id != null) {
              const staffName = s.name || s.fullName || s.username || "";
              currentStaffLookup.set(String(s.id), staffName);
              currentStaffLookup.set(Number(s.id), staffName);
              if (s.userId != null) {
                currentStaffLookup.set(String(s.userId), staffName);
                currentStaffLookup.set(Number(s.userId), staffName);
              }
            }
          });
        }
      } catch (lookupError) {
        currentStaffLookup =
          staffLookup instanceof Map ? staffLookup : new Map();
      }

      await Promise.all(
        admissions.map(async (admission) => {
          let nursingCareHistory = await getNursingByAdmissionId(admission.id);

          // Apply organization filter defensively
          nursingCareHistory = filterByOrganization(
            Array.isArray(nursingCareHistory)
              ? nursingCareHistory
              : nursingCareHistory
              ? [nursingCareHistory]
              : [],
            user,
          );

          // Enrich with nurseName from staff lookup
          if (
            Array.isArray(nursingCareHistory) &&
            nursingCareHistory.length > 0
          ) {
            nursingCareHistory = nursingCareHistory.map((care) => {
              const enriched = { ...care };
              if (enriched.nurseId && currentStaffLookup.size > 0) {
                const staffId = String(enriched.nurseId);
                const staffName =
                  currentStaffLookup.get(staffId) ||
                  currentStaffLookup.get(Number(enriched.nurseId));
                if (staffName) enriched.nurseName = staffName;
              }
              return enriched;
            });
          }

          nursingCareResults[admission.id] = nursingCareHistory;
        }),
      );
      setCareList(nursingCareResults);
    } catch (error) {
      console.error("Failed to fetch nursing care", error);
    }
  };

  const fetchKardexDeviceProcedures = async (admissions) => {
    try {
      const procedureResults = {};

      // Reload staff lookup data to ensure we have the latest data
      let currentStaffLookup;
      try {
        const staff = await getAllStaff().catch(() => []);
        const filteredStaff = filterByOrganization(staff || [], user);
        currentStaffLookup = new Map();
        if (Array.isArray(filteredStaff) && filteredStaff.length) {
          filteredStaff.forEach((s) => {
            if (s && s.id != null) {
              const staffName = s.name || s.fullName || s.username || "";
              currentStaffLookup.set(String(s.id), staffName);
              currentStaffLookup.set(Number(s.id), staffName);
              if (s.userId != null) {
                currentStaffLookup.set(String(s.userId), staffName);
                currentStaffLookup.set(Number(s.userId), staffName);
              }
            }
          });
        }
      } catch (lookupError) {
        currentStaffLookup =
          staffLookup instanceof Map ? staffLookup : new Map();
      }

      await Promise.all(
        admissions.map(async (admission) => {
          let procedureHistory = await getProceduresByAdmissionId(admission.id);

          // Apply organization filter defensively
          procedureHistory = filterByOrganization(
            Array.isArray(procedureHistory)
              ? procedureHistory
              : procedureHistory
              ? [procedureHistory]
              : [],
            user,
          );

          // Enrich with nurseName from staff lookup
          if (Array.isArray(procedureHistory) && procedureHistory.length > 0) {
            procedureHistory = procedureHistory.map((procedure) => {
              const enriched = { ...procedure };
              if (enriched.nurseId && currentStaffLookup.size > 0) {
                const staffId = String(enriched.nurseId);
                const staffName =
                  currentStaffLookup.get(staffId) ||
                  currentStaffLookup.get(Number(enriched.nurseId));
                if (staffName) enriched.nurseName = staffName;
              }
              return enriched;
            });
          }

          procedureResults[admission.id] = procedureHistory;
        }),
      );
      setProcedureList(procedureResults);
    } catch (error) {
      console.error("Failed to fetch device procedures", error);
    }
  };

  const fetchKardexMobility = async (admissions) => {
    try {
      const mobilityResults = {};

      // Reload staff lookup data to ensure we have the latest data
      let currentStaffLookup;
      try {
        const staff = await getAllStaff().catch(() => []);
        const filteredStaff = filterByOrganization(staff || [], user);
        currentStaffLookup = new Map();
        if (Array.isArray(filteredStaff) && filteredStaff.length) {
          filteredStaff.forEach((s) => {
            if (s && s.id != null) {
              const staffName = s.name || s.fullName || s.username || "";
              currentStaffLookup.set(String(s.id), staffName);
              currentStaffLookup.set(Number(s.id), staffName);
              if (s.userId != null) {
                currentStaffLookup.set(String(s.userId), staffName);
                currentStaffLookup.set(Number(s.userId), staffName);
              }
            }
          });
        }
      } catch (lookupError) {
        currentStaffLookup =
          staffLookup instanceof Map ? staffLookup : new Map();
      }

      await Promise.all(
        admissions.map(async (admission) => {
          let mobilityHistory = await getMobilityByPatientAndAdmission(
            patientId,
            admission.id,
          );

          // Apply organization filter defensively
          mobilityHistory = filterByOrganization(
            Array.isArray(mobilityHistory)
              ? mobilityHistory
              : mobilityHistory
              ? [mobilityHistory]
              : [],
            user,
          );

          // Enrich with nurseName from staff lookup
          if (Array.isArray(mobilityHistory) && mobilityHistory.length > 0) {
            mobilityHistory = mobilityHistory.map((mobility) => {
              const enriched = { ...mobility };
              if (enriched.nurseId && currentStaffLookup.size > 0) {
                const staffId = String(enriched.nurseId);
                const staffName =
                  currentStaffLookup.get(staffId) ||
                  currentStaffLookup.get(Number(enriched.nurseId));
                if (staffName) enriched.nurseName = staffName;
              }
              return enriched;
            });
          }

          mobilityResults[admission.id] = mobilityHistory;
        }),
      );
      setMobilityList(mobilityResults);
    } catch (error) {
      console.error("Failed to fetch mobility", error);
    }
  };

  const fetchKardexNurseNotes = async (admissions) => {
    try {
      const notesResults = {};

      // Reload staff lookup data to ensure we have the latest data (state might not be updated yet)
      let currentStaffLookup;
      try {
        const staff = await getAllStaff().catch(() => []);
        const filteredStaff = filterByOrganization(staff || [], user);

        // Build staff lookup map
        currentStaffLookup = new Map();
        if (Array.isArray(filteredStaff) && filteredStaff.length) {
          filteredStaff.forEach((s) => {
            if (s && s.id != null) {
              const staffName = s.name || s.fullName || s.username || "";
              currentStaffLookup.set(String(s.id), staffName);
              currentStaffLookup.set(Number(s.id), staffName);
              if (s.userId != null) {
                currentStaffLookup.set(String(s.userId), staffName);
                currentStaffLookup.set(Number(s.userId), staffName);
              }
            }
          });
        }
      } catch (lookupError) {
        console.error(
          "Failed to reload staff lookup data in fetchKardexNurseNotes:",
          lookupError,
        );
        // Fallback to state if reload fails
        currentStaffLookup =
          staffLookup instanceof Map ? staffLookup : new Map();
      }

      await Promise.all(
        admissions.map(async (admission) => {
          let notesHistory = await getNotesByPatientAndAdmission(
            patientId,
            admission.id,
          );

          // Apply organization filter defensively
          notesHistory = filterByOrganization(
            Array.isArray(notesHistory)
              ? notesHistory
              : notesHistory
              ? [notesHistory]
              : [],
            user,
          );

          // Enrich notes with nurseName from staff lookup
          if (Array.isArray(notesHistory) && notesHistory.length > 0) {
            notesHistory = notesHistory.map((note) => {
              // Create a copy to avoid mutating the original
              const enrichedNote = { ...note };

              // Enrich nurseName from nurseId (staff ID)
              if (enrichedNote.nurseId) {
                if (currentStaffLookup.size > 0) {
                  const staffId = String(enrichedNote.nurseId);
                  const staffName =
                    currentStaffLookup.get(staffId) ||
                    currentStaffLookup.get(Number(enrichedNote.nurseId));
                  if (staffName) {
                    enrichedNote.nurseName = staffName;
                  } else if (!enrichedNote.nurseName) {
                    // If lookup failed but we have nurseId, at least set something
                    enrichedNote.nurseName = String(enrichedNote.nurseId);
                  }
                } else if (!enrichedNote.nurseName) {
                  // If lookup is empty but we have nurseId, at least set something
                  enrichedNote.nurseName = String(enrichedNote.nurseId);
                }
              }

              return enrichedNote;
            });
          }

          notesResults[admission.id] = notesHistory;
        }),
      );
      setNotesList(notesResults);
    } catch (error) {
      console.error("Failed to fetch nurse notes", error);
    }
  };

  const fetchKardexCommunication = async (admissions) => {
    try {
      const communicationResults = {};

      // Reload staff lookup data to ensure we have the latest data
      let currentStaffLookup;
      try {
        const staff = await getAllStaff().catch(() => []);
        const filteredStaff = filterByOrganization(staff || [], user);
        currentStaffLookup = new Map();
        if (Array.isArray(filteredStaff) && filteredStaff.length) {
          filteredStaff.forEach((s) => {
            if (s && s.id != null) {
              const staffName = s.name || s.fullName || s.username || "";
              currentStaffLookup.set(String(s.id), staffName);
              currentStaffLookup.set(Number(s.id), staffName);
              if (s.userId != null) {
                currentStaffLookup.set(String(s.userId), staffName);
                currentStaffLookup.set(Number(s.userId), staffName);
              }
            }
          });
        }
      } catch (lookupError) {
        currentStaffLookup =
          staffLookup instanceof Map ? staffLookup : new Map();
      }

      await Promise.all(
        admissions.map(async (admission) => {
          let communicationHistory =
            await getCommunicationByPatientAndAdmission(
              patientId,
              admission.id,
            );

          // Apply organization filter defensively
          communicationHistory = filterByOrganization(
            Array.isArray(communicationHistory)
              ? communicationHistory
              : communicationHistory
              ? [communicationHistory]
              : [],
            user,
          );

          // Enrich with nurseName from staff lookup
          if (
            Array.isArray(communicationHistory) &&
            communicationHistory.length > 0
          ) {
            communicationHistory = communicationHistory.map((communication) => {
              const enriched = { ...communication };
              if (enriched.nurseId && currentStaffLookup.size > 0) {
                const staffId = String(enriched.nurseId);
                const staffName =
                  currentStaffLookup.get(staffId) ||
                  currentStaffLookup.get(Number(enriched.nurseId));
                if (staffName) enriched.nurseName = staffName;
              }
              return enriched;
            });
          }

          communicationResults[admission.id] = communicationHistory;
        }),
      );
      setCommunicationList(communicationResults);
    } catch (error) {
      console.error("Failed to fetch communication", error);
    }
  };

  const fetchKardexMiscAlert = async (admissions) => {
    try {
      const miscAlertResults = {};

      // Reload staff lookup data to ensure we have the latest data
      let currentStaffLookup;
      try {
        const staff = await getAllStaff().catch(() => []);
        const filteredStaff = filterByOrganization(staff || [], user);
        currentStaffLookup = new Map();
        if (Array.isArray(filteredStaff) && filteredStaff.length) {
          filteredStaff.forEach((s) => {
            if (s && s.id != null) {
              const staffName = s.name || s.fullName || s.username || "";
              currentStaffLookup.set(String(s.id), staffName);
              currentStaffLookup.set(Number(s.id), staffName);
              if (s.userId != null) {
                currentStaffLookup.set(String(s.userId), staffName);
                currentStaffLookup.set(Number(s.userId), staffName);
              }
            }
          });
        }
      } catch (lookupError) {
        currentStaffLookup =
          staffLookup instanceof Map ? staffLookup : new Map();
      }

      await Promise.all(
        admissions.map(async (admission) => {
          let miscAlertHistory = await getMiscByAdmission(admission.id);

          // Apply organization filter defensively
          miscAlertHistory = filterByOrganization(
            Array.isArray(miscAlertHistory)
              ? miscAlertHistory
              : miscAlertHistory
              ? [miscAlertHistory]
              : [],
            user,
          );

          // Enrich with nurseName from staff lookup
          if (Array.isArray(miscAlertHistory) && miscAlertHistory.length > 0) {
            miscAlertHistory = miscAlertHistory.map((misc) => {
              const enriched = { ...misc };
              if (enriched.nurseId && currentStaffLookup.size > 0) {
                const staffId = String(enriched.nurseId);
                const staffName =
                  currentStaffLookup.get(staffId) ||
                  currentStaffLookup.get(Number(enriched.nurseId));
                if (staffName) enriched.nurseName = staffName;
              }
              return enriched;
            });
          }

          miscAlertResults[admission.id] = miscAlertHistory;
        }),
      );
      setMiscAlertList(miscAlertResults);
    } catch (error) {
      console.error("Failed to fetch misc alerts", error);
    }
  };

  const fetchKardexMedications = async (admissions) => {
    try {
      const medicationsResults = {};

      // Reload staff lookup data to ensure we have the latest data
      let currentStaffLookup;
      try {
        const staff = await getAllStaff().catch(() => []);
        const filteredStaff = filterByOrganization(staff || [], user);
        currentStaffLookup = new Map();
        if (Array.isArray(filteredStaff) && filteredStaff.length) {
          filteredStaff.forEach((s) => {
            if (s && s.id != null) {
              const staffName = s.name || s.fullName || s.username || "";
              currentStaffLookup.set(String(s.id), staffName);
              currentStaffLookup.set(Number(s.id), staffName);
              if (s.userId != null) {
                currentStaffLookup.set(String(s.userId), staffName);
                currentStaffLookup.set(Number(s.userId), staffName);
              }
            }
          });
        }
      } catch (lookupError) {
        currentStaffLookup =
          staffLookup instanceof Map ? staffLookup : new Map();
      }

      await Promise.all(
        admissions.map(async (admission) => {
          let medicationHistory = await getMedicationsByPatientAndAdmission(
            patientId,
            admission.id,
          );

          // Apply organization filter defensively
          medicationHistory = filterByOrganization(
            Array.isArray(medicationHistory)
              ? medicationHistory
              : medicationHistory
              ? [medicationHistory]
              : [],
            user,
          );

          // Enrich with nurseName from staff lookup
          if (
            Array.isArray(medicationHistory) &&
            medicationHistory.length > 0
          ) {
            medicationHistory = medicationHistory.map((medication) => {
              const enriched = { ...medication };
              if (enriched.nurseId && currentStaffLookup.size > 0) {
                const staffId = String(enriched.nurseId);
                const staffName =
                  currentStaffLookup.get(staffId) ||
                  currentStaffLookup.get(Number(enriched.nurseId));
                if (staffName) enriched.nurseName = staffName;
              }
              return enriched;
            });
          }

          // Store with both number and string keys to handle type mismatches
          const admissionIdKey = admission.id;
          medicationsResults[admissionIdKey] = medicationHistory;
          // Also store with string key if it's a number, and vice versa
          if (typeof admissionIdKey === "number") {
            medicationsResults[String(admissionIdKey)] = medicationHistory;
          } else if (typeof admissionIdKey === "string") {
            const numKey = Number(admissionIdKey);
            if (!isNaN(numKey)) {
              medicationsResults[numKey] = medicationHistory;
            }
          }
        }),
      );
      setMedicationList(medicationsResults);
      console.log("medication", medicationsResults);
    } catch (error) {
      console.error("Failed to fetch medications", error);
    }
  };

  const fetchKardexIvFluids = async (admissions) => {
    try {
      const ivFluidResults = {};

      // Reload staff lookup data to ensure we have the latest data
      let currentStaffLookup;
      try {
        const staff = await getAllStaff().catch(() => []);
        const filteredStaff = filterByOrganization(staff || [], user);
        currentStaffLookup = new Map();
        if (Array.isArray(filteredStaff) && filteredStaff.length) {
          filteredStaff.forEach((s) => {
            if (s && s.id != null) {
              const staffName = s.name || s.fullName || s.username || "";
              currentStaffLookup.set(String(s.id), staffName);
              currentStaffLookup.set(Number(s.id), staffName);
              if (s.userId != null) {
                currentStaffLookup.set(String(s.userId), staffName);
                currentStaffLookup.set(Number(s.userId), staffName);
              }
            }
          });
        }
      } catch (lookupError) {
        currentStaffLookup =
          staffLookup instanceof Map ? staffLookup : new Map();
      }

      await Promise.all(
        admissions.map(async (admission) => {
          let ivFluidHistory = await getFluidsByAdmissionId(admission.id);

          // Apply organization filter defensively
          ivFluidHistory = filterByOrganization(
            Array.isArray(ivFluidHistory)
              ? ivFluidHistory
              : ivFluidHistory
              ? [ivFluidHistory]
              : [],
            user,
          );

          // Enrich with nurseName from staff lookup
          if (Array.isArray(ivFluidHistory) && ivFluidHistory.length > 0) {
            ivFluidHistory = ivFluidHistory.map((fluid) => {
              const enriched = { ...fluid };
              if (enriched.nurseId && currentStaffLookup.size > 0) {
                const staffId = String(enriched.nurseId);
                const staffName =
                  currentStaffLookup.get(staffId) ||
                  currentStaffLookup.get(Number(enriched.nurseId));
                if (staffName) enriched.nurseName = staffName;
              }
              return enriched;
            });
          }

          ivFluidResults[admission.id] = ivFluidHistory;
        }),
      );
      setFluidList(ivFluidResults);
    } catch (error) {
      console.error("Failed to fetch iv-fluid", error);
    }
  };

  const fetchPatientDetails = async () => {
    try {
      const data = await getPatientById(patientId);
      setPatientInfo(data);
    } catch (error) {
      console.error("Failed to fetch patient info", error);
    }
  };

  const fetchAllConsumables = async (admissions) => {
    try {
      const consumableResults = {};

      // Reload staff lookup data to ensure we have the latest data (state might not be updated yet)
      let currentStaffLookup;
      try {
        const staff = await getAllStaff().catch(() => []);
        const filteredStaff = filterByOrganization(staff || [], user);

        // Build staff lookup map
        currentStaffLookup = new Map();
        if (Array.isArray(filteredStaff) && filteredStaff.length) {
          filteredStaff.forEach((s) => {
            if (s && s.id != null) {
              const staffName = s.name || s.fullName || s.username || "";
              currentStaffLookup.set(String(s.id), staffName);
              currentStaffLookup.set(Number(s.id), staffName);
              if (s.userId != null) {
                currentStaffLookup.set(String(s.userId), staffName);
                currentStaffLookup.set(Number(s.userId), staffName);
              }
            }
          });
        }
      } catch (lookupError) {
        console.error(
          "Failed to reload staff lookup data in fetchAllConsumables:",
          lookupError,
        );
        // Fallback to state if reload fails
        currentStaffLookup =
          staffLookup instanceof Map ? staffLookup : new Map();
      }

      await Promise.all(
        admissions.map(async (admission) => {
          let consumables = await getByAdmissionId(admission.id);

          // Apply organization filter defensively
          consumables = filterByOrganization(
            Array.isArray(consumables)
              ? consumables
              : consumables
              ? [consumables]
              : [],
            user,
          );

          // Enrich consumables with usedByName from staff lookup
          if (Array.isArray(consumables) && consumables.length > 0) {
            consumables = consumables.map((consumable) => {
              // Create a copy to avoid mutating the original
              const enrichedConsumable = { ...consumable };

              // Enrich usedByName from usedBy (staff ID)
              if (enrichedConsumable.usedBy) {
                if (currentStaffLookup.size > 0) {
                  const staffId = String(enrichedConsumable.usedBy);
                  const staffName =
                    currentStaffLookup.get(staffId) ||
                    currentStaffLookup.get(Number(enrichedConsumable.usedBy));
                  if (staffName) {
                    enrichedConsumable.usedByName = staffName;
                  } else if (!enrichedConsumable.usedByName) {
                    // If lookup failed but we have usedBy, at least set something
                    enrichedConsumable.usedByName = String(
                      enrichedConsumable.usedBy,
                    );
                  }
                } else if (!enrichedConsumable.usedByName) {
                  // If lookup is empty but we have usedBy, at least set something
                  enrichedConsumable.usedByName = String(
                    enrichedConsumable.usedBy,
                  );
                }
              }

              return enrichedConsumable;
            });
          }

          consumableResults[admission.id] = consumables;
        }),
      );

      setConsumableList(consumableResults); // Store grouped data
      console.log("Consumables enriched with usedByName:", consumableResults);
    } catch (error) {
      console.error("Failed to fetch consumables by admission", error);
    }
  };

  // Fetch hospital/organization information for PDF header
  const fetchHospitalInfo = async () => {
    try {
      const storedUser = localStorage.getItem("user");
      let organizationId = null;
      let organizationName = null;
      let organizationAddress = null;
      let organizationPhone = null;

      if (storedUser) {
        try {
          const user = JSON.parse(storedUser);
          organizationId =
            user?.organizationId || localStorage.getItem("organizationId");
          organizationName = user?.organizationName;

          if (organizationId && typeof organizationId === "string") {
            organizationId = parseInt(organizationId, 10);
          }
        } catch (e) {
          console.error("[IpdReports] Error parsing stored user:", e);
        }
      }

      // Try to get organization name from utility function
      if (!organizationName) {
        organizationName = getOrganizationName(null); // Pass null to use localStorage
      }

      // Always fetch full organization data if we have organizationId (to get address)
      if (organizationId && organizationId > 0) {
        try {
          // Try hospital organizations first
          const { getHospitalOrganizationById } = await import(
            "../../services/hospitalOrganizationService"
          );
          try {
            const hospitalOrg = await getHospitalOrganizationById(
              organizationId,
            );
            console.log(
              `[IpdReports] Full hospital organization response:`,
              hospitalOrg,
            );

            if (hospitalOrg) {
              // Get organization name if not already set
              if (!organizationName) {
                organizationName = hospitalOrg.name || null;
              }

              // Try to get address from various possible fields
              // Check single address field first
              if (hospitalOrg.address) {
                organizationAddress = hospitalOrg.address;
              } else if (hospitalOrg.location) {
                organizationAddress = hospitalOrg.location;
              } else if (hospitalOrg.fullAddress) {
                organizationAddress = hospitalOrg.fullAddress;
              } else {
                // Construct address from separate fields (address, city, state, pincode)
                const addressParts = [];
                if (hospitalOrg.address) addressParts.push(hospitalOrg.address);
                if (hospitalOrg.streetAddress)
                  addressParts.push(hospitalOrg.streetAddress);
                if (hospitalOrg.city) addressParts.push(hospitalOrg.city);
                if (hospitalOrg.state) addressParts.push(hospitalOrg.state);
                if (hospitalOrg.pincode) addressParts.push(hospitalOrg.pincode);
                if (hospitalOrg.zipCode) addressParts.push(hospitalOrg.zipCode);

                if (addressParts.length > 0) {
                  organizationAddress = addressParts.join(", ");
                }
              }

              console.log(`[IpdReports] ✅ Fetched hospital organization:`, {
                name: organizationName,
                address: organizationAddress,
                rawFields: {
                  address: hospitalOrg.address,
                  location: hospitalOrg.location,
                  city: hospitalOrg.city,
                  state: hospitalOrg.state,
                  pincode: hospitalOrg.pincode,
                },
              });
              organizationPhone =
                hospitalOrg.phone ||
                hospitalOrg.mobile ||
                hospitalOrg.contactNumber ||
                hospitalOrg.phoneNumber ||
                organizationPhone;
            }
          } catch (hospitalError) {
            console.log(
              `[IpdReports] Hospital organization not found, trying regular organizations...`,
            );
            // If hospital organization not found, try regular organizations
            try {
              const { getOrganizationById } = await import(
                "../../services/organizationService"
              );
              const org = await getOrganizationById(organizationId);
              console.log(
                `[IpdReports] Full regular organization response:`,
                org,
              );

              if (org) {
                // Get organization name if not already set
                if (!organizationName) {
                  organizationName = org.name || null;
                }

                // Try to get address from various possible fields
                if (org.address) {
                  organizationAddress = org.address;
                } else if (org.location) {
                  organizationAddress = org.location;
                } else if (org.fullAddress) {
                  organizationAddress = org.fullAddress;
                } else {
                  // Construct address from separate fields
                  const addressParts = [];
                  if (org.address) addressParts.push(org.address);
                  if (org.streetAddress) addressParts.push(org.streetAddress);
                  if (org.city) addressParts.push(org.city);
                  if (org.state) addressParts.push(org.state);
                  if (org.pincode) addressParts.push(org.pincode);
                  if (org.zipCode) addressParts.push(org.zipCode);

                  if (addressParts.length > 0) {
                    organizationAddress = addressParts.join(", ");
                  }
                }
                organizationPhone =
                  org.phone ||
                  org.mobile ||
                  org.contactNumber ||
                  org.phoneNumber ||
                  organizationPhone;
              }
            } catch (orgError) {
              console.warn(
                `[IpdReports] Organization ${organizationId} not found in either service`,
              );
            }
          }
        } catch (error) {
          console.error(
            `[IpdReports] Error fetching organization details:`,
            error,
          );
        }
      }

      // Update state with fetched or default values
      if (organizationName) {
        setHospitalName(organizationName.toUpperCase());
      }
      if (organizationAddress) {
        setHospitalAddress(organizationAddress);
      }
      if (organizationPhone) {
        setHospitalPhone(String(organizationPhone));
      }
    } catch (error) {
      console.error("[IpdReports] Error in fetchHospitalInfo:", error);
    }
  };

  const fetchPatientLabReports = async (admissions) => {
    try {
      const LabResults = {};

      // Fetch all lab tests from base table (reference data for all organizations) to resolve test names
      let labTestsMap = new Map();
      try {
        const allLabTests = await getAllLabTests(); // Fetches from base table
        (Array.isArray(allLabTests) ? allLabTests : []).forEach((lt) => {
          if (lt.id) {
            labTestsMap.set(lt.id, lt);
          }
        });
        console.log(
          `[IpdReports] Loaded ${allLabTests.length} lab tests from base table for name resolution`,
        );
      } catch (labTestError) {
        console.warn(
          "[IpdReports] Could not load lab tests list for name resolution:",
          labTestError,
        );
      }

      // Helper function to normalize strings for comparison
      const normalize = (s) => (s || "").toString().trim().toLowerCase();

      // Get current staff lookup map for enriching labName (path desk staff)
      const currentStaffLookup =
        staffLookup instanceof Map ? staffLookup : new Map();

      await Promise.all(
        admissions.map(async (admission) => {
          let labTests = await getLabTestsByAdmissionId(admission.id);

          // Apply organization filter defensively
          labTests = filterByOrganization(
            Array.isArray(labTests) ? labTests : labTests ? [labTests] : [],
            user,
          );

          // Ensure labTests is an array
          const labTestsArray = Array.isArray(labTests)
            ? labTests
            : labTests
            ? [labTests]
            : [];

          // Resolve test names from lab test IDs (lab tests are reference data in base table)
          const labTestsWithResolvedNames = labTestsArray.map((lab) => {
            // Resolve test name from lab test ID first, then fallback to lab's test name
            let resolvedTestName =
              lab.testName ||
              lab.test_name ||
              lab.labTestName ||
              lab.name ||
              "—";

            // Try to resolve from lab test ID (testId or labTestId)
            const labTestId = lab.testId || lab.labTestId || lab.test_id;
            if (labTestId && labTestsMap.has(labTestId)) {
              const labTest = labTestsMap.get(labTestId);
              resolvedTestName =
                labTest.testName ||
                labTest.name ||
                labTest.test_name ||
                labTest.labTestName ||
                resolvedTestName;
              console.log(
                `[IpdReports] Resolved test name from labTestId ${labTestId}: "${resolvedTestName}"`,
              );
            } else if (resolvedTestName && resolvedTestName !== "—") {
              // Fallback: try to match by normalized name
              const normalizedLabTestName = normalize(resolvedTestName);
              for (const [id, labTest] of labTestsMap.entries()) {
                const ltName = normalize(
                  labTest.testName ||
                    labTest.name ||
                    labTest.test_name ||
                    labTest.labTestName,
                );
                if (
                  ltName === normalizedLabTestName &&
                  normalizedLabTestName !== ""
                ) {
                  resolvedTestName =
                    labTest.testName ||
                    labTest.name ||
                    labTest.test_name ||
                    labTest.labTestName ||
                    resolvedTestName;
                  console.log(
                    `[IpdReports] Resolved test name from name match "${normalizedLabTestName}": "${resolvedTestName}"`,
                  );
                  break;
                }
              }
            }

            return {
              ...lab,
              resolvedTestName: resolvedTestName,
            };
          });

          // Enrich lab tests with labName from staff lookup (labId refers to path desk staff)
          if (
            labTestsWithResolvedNames.length > 0 &&
            currentStaffLookup.size > 0
          ) {
            labTestsWithResolvedNames.forEach((lab) => {
              // Always enrich labName from labId (path desk staff ID) if labId exists
              // This ensures we have the correct name even if backend returns empty or incorrect labName
              if (lab.labId) {
                const staffId = String(lab.labId);
                const staffName =
                  currentStaffLookup.get(staffId) ||
                  currentStaffLookup.get(Number(lab.labId));
                if (staffName) {
                  lab.labName = staffName;
                }
              }
            });
          }

          // Deduplication: Use record ID first, then fall back to testName + testDate
          const uniqueLabTestsMap = new Map();
          const seenIds = new Set(); // Track seen record IDs to prevent exact duplicates

          // Deduplicate lab tests - group by testId + testDate, keep the most complete record
          labTestsWithResolvedNames.forEach((lab) => {
            // First, check if we've seen this exact record ID (exact duplicate)
            if (lab.id !== null && lab.id !== undefined) {
              if (seenIds.has(lab.id)) {
                return; // Skip exact duplicate
              }
              seenIds.add(lab.id);
            }

            // Normalize test name (trim and lowercase for comparison)
            const normalizedTestName = normalize(
              lab.resolvedTestName || lab.testName || "",
            );
            const testId = lab.testId || normalizedTestName;

            // Normalize test date for consistent comparison
            let normalizedDateStr = "";
            if (lab.testDate) {
              if (Array.isArray(lab.testDate)) {
                normalizedDateStr = JSON.stringify(lab.testDate);
              } else {
                // Convert to string and normalize
                normalizedDateStr = String(lab.testDate).trim();
              }
            }

            // Create unique key based on normalized testId/testName + normalized testDate
            const uniqueKey = `${testId}-${normalizedDateStr}`;

            // Check if we already have this test for this date
            if (uniqueLabTestsMap.has(uniqueKey)) {
              const existingLab = uniqueLabTestsMap.get(uniqueKey);

              // Prefer the record with more complete information (has result, has labName, has id, or later id)
              const existingScore =
                (existingLab.testResult ? 2 : 0) +
                (existingLab.labName ? 1 : 0) +
                (existingLab.id ? 1 : 0);
              const currentScore =
                (lab.testResult ? 2 : 0) +
                (lab.labName ? 1 : 0) +
                (lab.id ? 1 : 0);

              // Keep the one with more complete info, or the one with higher id if scores are equal
              if (
                currentScore > existingScore ||
                (currentScore === existingScore &&
                  (lab.id || 0) > (existingLab.id || 0))
              ) {
                uniqueLabTestsMap.set(uniqueKey, lab);
              }
            } else {
              // First occurrence of this testId + testDate combination
              uniqueLabTestsMap.set(uniqueKey, lab);
            }
          });

          // Convert Map back to array (only unique values)
          const uniqueLabTests = Array.from(uniqueLabTestsMap.values());

          console.log(
            `Admission ${admission.id}: Original ${labTestsArray.length} tests, Unique ${uniqueLabTests.length} tests`,
          );

          LabResults[admission.id] = uniqueLabTests;
        }),
      );
      setLabTestList(LabResults);
      console.log("setLabTestList", LabResults);
    } catch (error) {
      console.error("Failed to fetch lab test by admission", error);
    }
  };

  const StyledCell = (props) => (
    <TableCell
      {...props}
      sx={{
        border: "1px solid #ccc",
        ...props.sx,
      }}
    />
  );

  const fetchAllVisits = async (admissions) => {
    try {
      const visitResults = {};

      // Get current staff lookup map for enriching visitedByName
      const currentStaffLookup =
        staffLookup instanceof Map ? staffLookup : new Map();

      await Promise.all(
        admissions.map(async (admission) => {
          let visits = await getVisitsByAdmission(admission.id);

          // Apply organization filter defensively
          visits = filterByOrganization(
            Array.isArray(visits) ? visits : visits ? [visits] : [],
            user,
          );

          // Enrich visits with visitedByName from staff lookup
          if (
            Array.isArray(visits) &&
            visits.length > 0 &&
            currentStaffLookup.size > 0
          ) {
            visits = visits.map((visit) => {
              // Enrich visitedByName from visitedBy (staff/doctor ID)
              if (visit.visitedBy && !visit.visitedByName) {
                const staffId = String(visit.visitedBy);
                const staffName =
                  currentStaffLookup.get(staffId) ||
                  currentStaffLookup.get(Number(visit.visitedBy));
                if (staffName) {
                  visit.visitedByName = staffName;
                }
              }
              return visit;
            });
          }

          visitResults[admission.id] = visits;
        }),
      );
      setVisitList(visitResults); // Store grouped data
    } catch (error) {
      console.error("Failed to fetch visits by admission", error);
    }
  };

  const fetchAllAssignments = async (admissions) => {
    try {
      const assignmentResults = {};

      // Reload lookup data to ensure we have the latest data (state might not be updated yet)
      let currentStaffLookup, currentWardLookup, currentBedLookup;
      try {
        const [staff, wards, beds] = await Promise.all([
          getAllStaff().catch(() => []),
          getAllWards().catch(() => []),
          getAllBeds().catch(() => []),
        ]);

        // Filter by organization
        const filteredStaff = filterByOrganization(staff || [], user);
        const filteredWards = filterByOrganization(wards || [], user);
        const filteredBeds = filterByOrganization(beds || [], user);

        // Build staff lookup map
        currentStaffLookup = new Map();
        if (Array.isArray(filteredStaff) && filteredStaff.length) {
          filteredStaff.forEach((s) => {
            if (s && s.id != null) {
              const staffName = s.name || s.fullName || s.username || "";
              currentStaffLookup.set(String(s.id), staffName);
              currentStaffLookup.set(Number(s.id), staffName);
              if (s.userId != null) {
                currentStaffLookup.set(String(s.userId), staffName);
                currentStaffLookup.set(Number(s.userId), staffName);
              }
            }
          });
        }

        // Build ward lookup map
        currentWardLookup = new Map();
        if (Array.isArray(filteredWards) && filteredWards.length) {
          filteredWards.forEach((w) => {
            if (w && w.id != null) {
              const wardName = w.name || w.wardName || w.ward || "";
              currentWardLookup.set(Number(w.id), wardName);
              currentWardLookup.set(String(w.id), wardName);
            }
          });
        }

        // Build bed lookup map
        currentBedLookup = new Map();
        if (Array.isArray(filteredBeds) && filteredBeds.length) {
          filteredBeds.forEach((b) => {
            if (b && b.id != null) {
              const bedName = b.bedNumber || b.name || b.bed || "";
              currentBedLookup.set(Number(b.id), bedName);
              currentBedLookup.set(String(b.id), bedName);
            }
          });
        }
      } catch (lookupError) {
        console.error(
          "Failed to reload lookup data in fetchAllAssignments:",
          lookupError,
        );
        // Fallback to state if reload fails
        currentStaffLookup =
          staffLookup instanceof Map ? staffLookup : new Map();
        currentWardLookup = wardLookup instanceof Map ? wardLookup : new Map();
        currentBedLookup = bedLookup instanceof Map ? bedLookup : new Map();
      }

      for (const admission of admissions) {
        const data = await getAssignmentByAdmissionId(admission.id);
        // Filter by organization as defensive measure
        const filteredData = Array.isArray(data)
          ? filterByOrganization(data, user)
          : data
          ? filterByOrganization([data], user)[0] || null
          : null;

        let assignment;

        // If data is an array, get the latest assignment (most recent one)
        if (Array.isArray(filteredData) && filteredData.length > 0) {
          // Sort by creation date or id (assuming higher id = more recent)
          const sortedData = [...filteredData].sort((a, b) => {
            // Try to sort by createdAt if available
            if (a.createdAt && b.createdAt) {
              return new Date(b.createdAt) - new Date(a.createdAt);
            }
            // Fallback to sorting by id
            return (b.id || 0) - (a.id || 0);
          });
          assignment = sortedData[0]; // Get the most recent one
        } else {
          assignment = filteredData;
        }

        // Fetch correct doctor name using doctorId if available
        if (assignment && assignment.doctorId) {
          try {
            const doctor = await getDoctorById(assignment.doctorId);
            if (doctor && doctor.name) {
              assignment.doctorName = doctor.name; // Override with correct name from doctor service
            }
          } catch (doctorError) {
            console.error(
              `Failed to fetch doctor ${assignment.doctorId}:`,
              doctorError,
            );
          }
        }

        // Enrich nurseName from nurseId using currentStaffLookup
        // Always try to enrich if nurseId exists, even if nurseName is already present (to ensure accuracy)
        if (assignment && assignment.nurseId) {
          if (currentStaffLookup.size > 0) {
            const raw = String(assignment.nurseId);
            const ids = raw
              .split(",")
              .map((s) => s.trim())
              .filter(Boolean);
            const names = ids.map((id) => {
              const name =
                currentStaffLookup.get(String(id)) ||
                currentStaffLookup.get(Number(id));
              return name || id; // Fallback to ID if name not found
            });
            const enrichedName = names.join(", ");
            // Update if enriched name is different from raw IDs (meaning we found actual names)
            // or if nurseName was missing
            if (enrichedName !== raw || !assignment.nurseName) {
              assignment.nurseName = enrichedName;
            }
          } else if (!assignment.nurseName) {
            // If lookup is empty but we have nurseId, at least set something
            assignment.nurseName = String(assignment.nurseId);
          }
        }

        // Enrich wardName from wardId using currentWardLookup
        // Always try to enrich if wardId exists
        if (assignment && assignment.wardId != null) {
          if (currentWardLookup.size > 0) {
            const wardName =
              currentWardLookup.get(Number(assignment.wardId)) ||
              currentWardLookup.get(String(assignment.wardId)); // Try both number and string keys
            if (wardName) {
              assignment.wardName = wardName;
            } else if (!assignment.wardName) {
              // If lookup failed but we have wardId, log for debugging
              console.warn(
                `Ward name not found for wardId: ${assignment.wardId}`,
              );
            }
          } else if (!assignment.wardName) {
            // If lookup is empty but we have wardId, at least set something
            assignment.wardName = String(assignment.wardId);
          }
        }

        // Enrich bedName from bedId using currentBedLookup
        // Always try to enrich if bedId exists
        if (assignment && assignment.bedId != null) {
          if (currentBedLookup.size > 0) {
            const bedName =
              currentBedLookup.get(Number(assignment.bedId)) ||
              currentBedLookup.get(String(assignment.bedId)); // Try both number and string keys
            if (bedName) {
              assignment.bedName = bedName;
            } else if (!assignment.bedName) {
              // If lookup failed but we have bedId, log for debugging
              console.warn(`Bed name not found for bedId: ${assignment.bedId}`);
            }
          } else if (!assignment.bedName) {
            // If lookup is empty but we have bedId, at least set something
            assignment.bedName = String(assignment.bedId);
          }
        }

        // Store assignment with both number and string keys to handle type mismatches
        const admissionIdKey = admission.id;
        assignmentResults[admissionIdKey] = assignment;
        // Also store with string key if it's a number, and vice versa
        if (typeof admissionIdKey === "number") {
          assignmentResults[String(admissionIdKey)] = assignment;
        } else if (typeof admissionIdKey === "string") {
          const numKey = Number(admissionIdKey);
          if (!isNaN(numKey)) {
            assignmentResults[numKey] = assignment;
          }
        }

        console.log(
          `Assignment for admission ${
            admission.id
          } (type: ${typeof admission.id}):`,
          assignment,
        );
        console.log(
          `  - nurseId: ${assignment?.nurseId}, nurseName: ${assignment?.nurseName}`,
        );
        console.log(
          `  - wardId: ${assignment?.wardId}, wardName: ${assignment?.wardName}`,
        );
        console.log(
          `  - bedId: ${assignment?.bedId}, bedName: ${assignment?.bedName}`,
        );
        console.log(
          `  - Lookup sizes - Staff: ${currentStaffLookup.size}, Ward: ${currentWardLookup.size}, Bed: ${currentBedLookup.size}`,
        );
      }
      setAssignmentList(assignmentResults);
      console.log("All assignments:", assignmentResults);
      console.log("Assignment keys:", Object.keys(assignmentResults));
    } catch (error) {
      console.error("Failed to fetch assignments by admission", error);
    }
  };

  const fetchAllOperation = async (admissions) => {
    try {
      const operationResults = {};

      // Reload lookup data to ensure we have the latest data (state might not be updated yet)
      let currentStaffLookup;
      try {
        const staff = await getAllStaff().catch(() => []);
        const filteredStaff = filterByOrganization(staff || [], user);

        // Build staff lookup map
        currentStaffLookup = new Map();
        if (Array.isArray(filteredStaff) && filteredStaff.length) {
          filteredStaff.forEach((s) => {
            if (s && s.id != null) {
              const staffName = s.name || s.fullName || s.username || "";
              currentStaffLookup.set(String(s.id), staffName);
              currentStaffLookup.set(Number(s.id), staffName);
              if (s.userId != null) {
                currentStaffLookup.set(String(s.userId), staffName);
                currentStaffLookup.set(Number(s.userId), staffName);
              }
            }
          });
        }
      } catch (lookupError) {
        console.error(
          "Failed to reload staff lookup data in fetchAllOperation:",
          lookupError,
        );
        // Fallback to state if reload fails
        currentStaffLookup =
          staffLookup instanceof Map ? staffLookup : new Map();
      }

      await Promise.all(
        admissions.map(async (admission) => {
          let operations = await getByAdmission(admission.id);

          // Apply organization filter defensively
          operations = filterByOrganization(
            Array.isArray(operations)
              ? operations
              : operations
              ? [operations]
              : [],
            user,
          );

          // Enrich operations with names from IDs
          if (Array.isArray(operations) && operations.length > 0) {
            // Use Promise.all to handle async enrichment
            operations = await Promise.all(
              operations.map(async (operation) => {
                // Create a copy to avoid mutating the original
                const enrichedOperation = { ...operation };

                // Enrich surgeonName from surgeonId (doctor ID)
                if (
                  enrichedOperation.surgeonId &&
                  !enrichedOperation.surgeonName
                ) {
                  try {
                    // Try to get doctor name from assignment first (faster)
                    const assignment =
                      AssignmentList[admission.id] ||
                      AssignmentList[String(admission.id)] ||
                      AssignmentList[Number(admission.id)];
                    if (
                      assignment &&
                      assignment.doctorId === enrichedOperation.surgeonId
                    ) {
                      enrichedOperation.surgeonName = assignment.doctorName;
                    } else {
                      // Fetch doctor by ID
                      const doctor = await getDoctorById(
                        enrichedOperation.surgeonId,
                      );
                      if (doctor && doctor.name) {
                        enrichedOperation.surgeonName = doctor.name;
                      } else {
                        enrichedOperation.surgeonName = String(
                          enrichedOperation.surgeonId,
                        );
                      }
                    }
                  } catch (error) {
                    console.error(
                      `Failed to enrich surgeon name for operation ${enrichedOperation.id}:`,
                      error,
                    );
                    enrichedOperation.surgeonName = String(
                      enrichedOperation.surgeonId,
                    );
                  }
                }

                // Enrich nurseNames from nurseIds (comma-separated string of staff IDs)
                if (
                  enrichedOperation.nurseIds &&
                  !enrichedOperation.nurseNames
                ) {
                  if (currentStaffLookup.size > 0) {
                    const nurseIdString = String(enrichedOperation.nurseIds);
                    const nurseIds = nurseIdString
                      .split(",")
                      .map((id) => id.trim())
                      .filter(Boolean);
                    const nurseNames = nurseIds.map((id) => {
                      const name =
                        currentStaffLookup.get(String(id)) ||
                        currentStaffLookup.get(Number(id));
                      return name || id; // Fallback to ID if name not found
                    });
                    enrichedOperation.nurseNames = nurseNames.join(", ");
                  } else {
                    enrichedOperation.nurseNames = String(
                      enrichedOperation.nurseIds,
                    );
                  }
                }

                // Enrich anesthetistName from anesthetistId (staff ID)
                if (
                  enrichedOperation.anesthetistId &&
                  !enrichedOperation.anesthetistName
                ) {
                  if (currentStaffLookup.size > 0) {
                    const staffId = String(enrichedOperation.anesthetistId);
                    const staffName =
                      currentStaffLookup.get(staffId) ||
                      currentStaffLookup.get(
                        Number(enrichedOperation.anesthetistId),
                      );
                    if (staffName) {
                      enrichedOperation.anesthetistName = staffName;
                    } else {
                      enrichedOperation.anesthetistName = String(
                        enrichedOperation.anesthetistId,
                      );
                    }
                  } else {
                    enrichedOperation.anesthetistName = String(
                      enrichedOperation.anesthetistId,
                    );
                  }
                }

                return enrichedOperation;
              }),
            );
          }

          operationResults[admission.id] = operations;
        }),
      );

      setOperationList(operationResults);
    } catch (error) {
      console.error("Failed to fetch operations by admission", error);
    }
  };

  // ✅ ADD BELOW THIS (or any other fetch functions)
  const fetchPatientMedicineInventoryData = async (admissions) => {
    try {
      const results = {};

      await Promise.all(
        admissions.map(async (admission) => {
          const data = await getAdministrationHistory(admission.id);

          results[admission.id] = data || [];
        }),
      );

      setPatientMedicineInventory(results);
    } catch (error) {
      console.error("Failed to fetch administered medicines", error);
    }
  };

  const fetchAllTreatments = async (admissions) => {
    try {
      const treatmentResults = {};

      // Reload staff lookup data to ensure we have the latest data (state might not be updated yet)
      let currentStaffLookup;
      try {
        const staff = await getAllStaff().catch(() => []);
        const filteredStaff = filterByOrganization(staff || [], user);

        // Build staff lookup map
        currentStaffLookup = new Map();
        if (Array.isArray(filteredStaff) && filteredStaff.length) {
          filteredStaff.forEach((s) => {
            if (s && s.id != null) {
              const staffName = s.name || s.fullName || s.username || "";
              currentStaffLookup.set(String(s.id), staffName);
              currentStaffLookup.set(Number(s.id), staffName);
              if (s.userId != null) {
                currentStaffLookup.set(String(s.userId), staffName);
                currentStaffLookup.set(Number(s.userId), staffName);
              }
            }
          });
        }
      } catch (lookupError) {
        console.error(
          "Failed to reload staff lookup data in fetchAllTreatments:",
          lookupError,
        );
        // Fallback to state if reload fails
        currentStaffLookup =
          staffLookup instanceof Map ? staffLookup : new Map();
      }

      // Loop over each admission and fetch its treatments
      await Promise.all(
        admissions.map(async (admission) => {
          let treatments = await getTreatmentsByAdmissionId(admission.id);

          // Apply organization filter defensively
          treatments = filterByOrganization(
            Array.isArray(treatments)
              ? treatments
              : treatments
              ? [treatments]
              : [],
            user,
          );

          // Enrich treatments with performedByName from staff lookup
          if (Array.isArray(treatments) && treatments.length > 0) {
            treatments = treatments.map((treatment) => {
              // Create a copy to avoid mutating the original
              const enrichedTreatment = { ...treatment };

              // Enrich performedByName from performedBy (staff ID)
              if (enrichedTreatment.performedBy) {
                if (currentStaffLookup.size > 0) {
                  const staffId = String(enrichedTreatment.performedBy);
                  const staffName =
                    currentStaffLookup.get(staffId) ||
                    currentStaffLookup.get(
                      Number(enrichedTreatment.performedBy),
                    );
                  if (staffName) {
                    enrichedTreatment.performedByName = staffName;
                  } else if (!enrichedTreatment.performedByName) {
                    // If lookup failed but we have performedBy, at least set something
                    enrichedTreatment.performedByName = String(
                      enrichedTreatment.performedBy,
                    );
                  }
                } else if (!enrichedTreatment.performedByName) {
                  // If lookup is empty but we have performedBy, at least set something
                  enrichedTreatment.performedByName = String(
                    enrichedTreatment.performedBy,
                  );
                }
              }

              return enrichedTreatment;
            });
          }

          // Store treatments with both number and string keys to handle type mismatches
          const admissionIdKey = admission.id;
          treatmentResults[admissionIdKey] = treatments;
          // Also store with string key if it's a number, and vice versa
          if (typeof admissionIdKey === "number") {
            treatmentResults[String(admissionIdKey)] = treatments;
          } else if (typeof admissionIdKey === "string") {
            const numKey = Number(admissionIdKey);
            if (!isNaN(numKey)) {
              treatmentResults[numKey] = treatments;
            }
          }
        }),
      );

      setTreatmentList(treatmentResults); // Store grouped data
      console.log(
        "Treatments enriched with performedByName:",
        treatmentResults,
      );
      console.log("Treatment keys:", Object.keys(treatmentResults));
    } catch (error) {
      console.error("Failed to fetch treatments by admission", error);
    }
  };

  const fetchAllDischarge = async (admissions) => {
    try {
      const dischargeResults = {};
      await Promise.all(
        admissions.map(async (admission) => {
          let discharge = await getDischargesByAdmissionId(admission.id);

          // Apply organization filter defensively
          discharge = filterByOrganization(
            Array.isArray(discharge) ? discharge : discharge ? [discharge] : [],
            user,
          );

          dischargeResults[admission.id] = discharge;
        }),
      );
      setDischargeList(dischargeResults);
    } catch (error) {
      console.error("Failed to fetch discharges by admission", error);
    }
  };

  const fetchPatientAdmission = async () => {
    try {
      // For organization-specific users, some backends may not support
      // filtering by patientId correctly on /ipd-admissions/patient/{id}.
      // To keep all existing behavior intact and ensure data shows up for
      // hospital organizations, prefer getAll() and filter on the frontend
      // when organizationId is present. For common users (no organizationId),
      // continue using getAdmissionByPatientId as before.

      let admissions = [];

      const hasOrganization =
        user && user.organizationId && Number(user.organizationId) > 0;

      if (hasOrganization) {
        // Organization-specific user: fetch all admissions for this org
        const allAdmissions = await getAllAdmissions();
        const allArray = Array.isArray(allAdmissions) ? allAdmissions : [];

        // Filter by patientId (ensure numeric comparison is safe)
        const pidNum = Number(patientId);
        admissions = allArray.filter((a) => {
          const aPid = a?.patientId;
          return (
            aPid != null &&
            (Number(aPid) === pidNum || String(aPid) === String(patientId))
          );
        });
      } else {
        // Common user (no organization): keep old behavior
        const data = await getAdmissionByPatientId(patientId);
        admissions = Array.isArray(data) ? data : data ? [data] : [];
      }

      // Ensure we always work with an array
      const data = Array.isArray(admissions) ? admissions : [];

      setAdmissionList(data);
      // Each of these only depends on `data` (the admissions list) and writes
      // its own independent piece of state — they don't depend on each
      // other's results, so there's no reason to await them one at a time.
      // That serialized ~22 round trips (worse once each Kardex fetcher's own
      // getAllStaff()/per-admission calls are counted) into a single spinner.
      await Promise.all([
        fetchAllAssignments(data),
        fetchAllTreatments(data),
        fetchAllOperation(data),
        fetchAllConsumables(data),
        fetchAllVisits(data),
        fetchAllDischarge(data),
        fetchPatientLabReports(data),
        fetchIpdPrescriptions(data),
        fetchKardexMedicalHistory(data),
        fetchKardexVitalSigns(data),
        fetchKardexNutritions(data),
        fetchKardexElimination(data),
        fetchKardexInvestigation(data),
        fetchKardexNursingCare(data),
        fetchKardexDeviceProcedures(data),
        fetchKardexMobility(data),
        fetchKardexNurseNotes(data),
        fetchKardexCommunication(data),
        fetchKardexMiscAlert(data),
        fetchKardexMedications(data),
        fetchKardexIvFluids(data),
        fetchMedicineRequests(data),
        fetchPatientMedicineInventory(data),
        fetchPatientMedicineInventoryData(data),
      ]);
    } catch (error) {
      console.error("Failed to fetch patient admission", error);
    }
  };

  const fetchIpdPrescriptions = async (admissions) => {
    const grouped = {};
    (Array.isArray(admissions) ? admissions : []).forEach((admission) => {
      if (admission?.id != null) {
        grouped[admission.id] = [];
        grouped[String(admission.id)] = [];
      }
    });

    try {
      const data = await getIpdPrescriptionsByPatientId(patientId);
      const list = Array.isArray(data) ? data : data ? [data] : [];
      list.forEach((rx) => {
        const admissionId = rx?.admissionId ?? rx?.admission_id;
        if (admissionId != null && grouped[admissionId]) {
          grouped[admissionId].push(rx);
          grouped[String(admissionId)] = grouped[admissionId];
          return;
        }
        const matchedAdmission = (admissions || []).find((admission) => {
          const linkedId =
            admission?.prescriptionId ?? admission?.prescription_id;
          const rxId = rx?.id ?? rx?.prescriptionId ?? rx?.prescription_id;
          return (
            linkedId != null &&
            rxId != null &&
            String(linkedId) === String(rxId)
          );
        });
        if (matchedAdmission?.id != null) {
          grouped[matchedAdmission.id].push(rx);
          grouped[String(matchedAdmission.id)] = grouped[matchedAdmission.id];
        }
      });
    } catch (error) {
      console.error("Failed to fetch IPD prescriptions", error);
    }

    setIpdPrescriptionList(grouped);
  };

  const fetchMedicine = async () => {
    try {
      const data = await getMedicineList();
      setMedicine(data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchMedicineRequests = async (admissions) => {
    try {
      const requestsMap = {};
      await Promise.all(
        admissions.map(async (admission) => {
          try {
            const requests = await getRequestsByAdmissionId(admission.id);
            // Map requests by treatment ID for easy lookup
            requests.forEach((request) => {
              if (request.treatmentId) {
                requestsMap[request.treatmentId] = request;
              }
            });
          } catch (error) {
            console.error(
              `Failed to fetch medicine requests for admission ${admission.id}:`,
              error,
            );
          }
        }),
      );
      setMedicineRequests(requestsMap);
    } catch (error) {
      console.error("Failed to fetch medicine requests:", error);
    }
  };

  const fetchPatientMedicineInventory = async (admissions) => {
    try {
      const inventoryMap = {};
      await Promise.all(
        admissions.map(async (admission) => {
          try {
            const inventory = await getPatientMedicineInventory(admission.id);
            inventoryMap[admission.id] = inventory || [];
          } catch (error) {
            console.error(
              `Failed to fetch patient medicine inventory for admission ${admission.id}:`,
              error,
            );
            inventoryMap[admission.id] = [];
          }
        }),
      );
      setPatientMedicineInventory(inventoryMap);
    } catch (error) {
      console.error("Failed to fetch patient medicine inventory:", error);
    }
  };

  const handleTabChange = (admissionKey, newTabIndex) => {
    setActiveTabs((prev) => ({ ...prev, [admissionKey]: newTabIndex }));
  };

  const handleMenuOpen = (event, admissionId) => {
    setMenuAnchorEls((prev) => ({
      ...prev,
      [admissionId]: event.currentTarget,
    }));
  };

  const handleMenuClose = (admissionId) => {
    setMenuAnchorEls((prev) => ({
      ...prev,
      [admissionId]: null,
    }));
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSelectedPatient(null);
  };

  // Medicine Request Handlers
  const handleRequestMedicine = (treatment) => {
    setSelectedRequestTreatment(treatment);
    setOpenRequestModal(true);
  };

  const handleRequestModalClose = () => {
    setOpenRequestModal(false);
    setSelectedRequestTreatment(null);
  };

  const handleRequestSubmit = async () => {
    // Refresh data after request submission
    await fetchPatientAdmission();
    setOpenRequestModal(false);
    setSelectedRequestTreatment(null);
  };

  const handleIssueMedicine = (treatment, admission) => {
    if (!isPharmacyAdmin || !treatment) return;
    setSelectedIssueTreatment({
      ...treatment,
      admissionId: treatment.admissionId || admission?.id,
    });
    setOpenIssueMedicineModal(true);
  };

  const handleIssueMedicineClose = () => {
    setOpenIssueMedicineModal(false);
    setSelectedIssueTreatment(null);
  };

  const handleIssueMedicineSubmit = async () => {
    try {
      await fetchAllTreatments(AdmissionList);
    } catch (error) {
      console.error("[IpdReports] Failed to refresh after issuing medicine:", error);
    }
  };

  const handleReceiveMedicine = async (treatment) => {
    try {
      const request = medicineRequests[treatment.id];
      if (request) {
        const receiveData = {
          receivedByUserId: user?.id || 0,
          receivedByName: user?.name || user?.username || "Unknown",
          receivedDate: new Date().toISOString(),
        };

        await receiveMedicineRequest(request.id, receiveData);
        await fetchPatientAdmission(); // Refresh data
        alert("Medicine received successfully!");
      }
    } catch (error) {
      console.error("Error receiving medicine:", error);
      alert("Failed to mark medicine as received. Please try again.");
    }
  };

  const handleDispenseToPatient = async (treatment) => {
    try {
      const request = medicineRequests[treatment.id];
      if (request) {
        // Find the corresponding inventory item for this medicine
        const admissionId = treatment.admissionId;
        const inventoryItem = (
          patientMedicineInventory[admissionId] || []
        ).find((item) => item.medicineName === treatment.medicine);

        if (inventoryItem) {
          // Use the ward inventory administration modal
          setSelectedInventoryItem(inventoryItem);
          setOpenAdministrationModal(true);
        } else {
          // If no inventory item found, create a temporary one for administration
          // This handles the case where medicine is received but not yet in patient inventory
          const tempInventoryItem = {
            id: `temp-${treatment.id}`,
            patientId: patientInfo.id,
            admissionId: admissionId,
            medicineId: request.medicineId,
            medicineName: treatment.medicine,
            remainingQuantity: request.totalQuantity || 0,
            batchNumber: request.batchNumber || "N/A",
            expiryDate: request.expiryDate || null,
            issuedDate: request.issuedDate,
            issuedBy: request.issuedByName || "Pharmacy",
          };

          setSelectedInventoryItem(tempInventoryItem);
          setOpenAdministrationModal(true);
        }
      }
    } catch (error) {
      console.error("Error preparing medicine administration:", error);
      alert("Failed to prepare medicine administration. Please try again.");
    }
  };

  const handleReturnModalClose = () => {
    setOpenReturnModal(false);
    setSelectedReturnTreatment(null);
  };

  const handleReturnSubmit = async () => {
    await fetchPatientAdmission(); // Refresh data
    setOpenReturnModal(false);
    setSelectedReturnTreatment(null);
  };

  // Patient Medicine Administration Handlers
  const handleAdministerMedicine = (inventoryItem) => {
    setSelectedInventoryItem(inventoryItem);
    setOpenAdministrationModal(true);
  };

  const handleAdministrationModalClose = () => {
    setOpenAdministrationModal(false);
    setSelectedInventoryItem(null);
  };

  const handleAdministrationSubmit = async () => {
    try {
      // Find the corresponding treatment and mark the request as DISPENSED
      const treatment = Object.values(treatmentList)
        .flat()
        .find((t) => t.medicine === selectedInventoryItem?.medicineName);

      if (treatment) {
        const request = medicineRequests[treatment.id];
        if (request && request.status === "RECEIVED") {
          const dispenseData = {
            dispensedByUserId: user?.id || 0,
            dispensedByName: user?.name || user?.username || "Unknown",
            dispensedDate: new Date().toISOString(),
          };

          await dispenseMedicineRequest(request.id, dispenseData);
        }
      }
    } catch (error) {
      console.error("Error marking medicine as dispensed:", error);
    }

    await fetchPatientAdmission(); // Refresh data
    setOpenAdministrationModal(false);
    setSelectedInventoryItem(null);
  };

  const handleReturnPatientMedicine = async (inventoryItem) => {
    try {
      const returnData = {
        patientInventoryId: inventoryItem.id,
        patientId: patientInfo.id,
        admissionId: inventoryItem.admissionId,
        medicineId: inventoryItem.medicineId,
        medicineName: inventoryItem.medicineName,
        quantity: inventoryItem.remainingQuantity,
        returnReason: "Unused medicine - order changed or patient discharged",
        returnedBy: user?.name || user?.username || "Unknown",
        returnedDate: new Date().toISOString(),
      };

      await returnPatientMedicineToPharmacy(returnData);

      // Find the corresponding treatment and mark the request as RETURNED
      const treatment = Object.values(treatmentList)
        .flat()
        .find((t) => t.medicine === inventoryItem.medicineName);

      if (treatment) {
        const request = medicineRequests[treatment.id];
        if (
          request &&
          (request.status === "RECEIVED" || request.status === "DISPENSED")
        ) {
          const returnRequestData = {
            returnedByUserId: user?.id || 0,
            returnedByName: user?.name || user?.username || "Unknown",
            returnedDate: new Date().toISOString(),
            returnReason: "Unused medicine returned to pharmacy",
            returnedQuantity: inventoryItem.remainingQuantity,
          };

          await returnMedicineRequest(request.id, returnRequestData);
        }
      }

      await fetchPatientAdmission(); // Refresh data
      alert(
        "Medicine returned to pharmacy successfully! Status updated to RETURNED.",
      );
    } catch (error) {
      console.error("Error returning patient medicine:", error);
      alert("Failed to return medicine to pharmacy. Please try again.");
    }
  };

  const groupedData = null;
  const date = null;

const applyDynamicPageBreaks = () => {
 const sections = document.querySelectorAll(".table-section");

  sections.forEach((section) => {
    const rect = section.getBoundingClientRect();
    const height = rect.height;

    // 🔥 Strong control logic
    if (height > 200 && height < 800) {
      section.style.pageBreakBefore = "always";
      section.style.breakBefore = "page";
    }
  });
};
// page break

const resetPageBreaks = () => {
  const sections = document.querySelectorAll(".table-section");
  sections.forEach((section) => {
    section.style.pageBreakBefore = "auto";
    section.style.breakBefore = "auto";
  });
};

  // PDF changes

  const formatDateFromArray = (dateArray) => {
    if (Array.isArray(dateArray)) {
      const [year, month, day] = dateArray;
      // Create a JavaScript Date object to properly handle the date
      // JavaScript Date constructor expects 0-indexed months, so subtract 1
      const date = new Date(year, month - 1, day);
      return dayjs(date);
    }
    return dayjs(dateArray); // Fallback for ISO strings
  };

  // Helper function specifically for assignment dates
  const formatAssignmentDate = (dateArray) => {
    if (Array.isArray(dateArray)) {
      const [year, month, day] = dateArray;
      // For assignment dates, the backend sends 0-indexed months
      // Month 11 in the response = November (0-indexed), but we want October
      // So we need to subtract 1 from the month to get the correct month
      const date = new Date(year, month - 1, day);
      return dayjs(date);
    }
    return dayjs(dateArray); // Fallback for ISO strings
  };

  const formatLabTestDate = (dateArray) => {
    if (Array.isArray(dateArray)) {
      const [year, month, day] = dateArray;
      // For lab test dates, create a JavaScript Date object
      // JavaScript Date constructor expects 0-indexed months, so subtract 1
      const date = new Date(year, month - 1, day);
      return dayjs(date);
    }
    return dayjs(dateArray); // Fallback for ISO strings
  };

  const isDateTimeArray = (arr) =>
    Array.isArray(arr) && arr.length >= 6 && Number(arr[0]) > 1000;

  const parseTimeValue = (value) => {
    if (!value) return null;

    const finalize = (date) => (date && date.isValid() ? date : null);

    // Helper to build a time-only date object in local timezone
    // Uses a fixed date (1970-01-01) to avoid any date-related timezone issues
    const buildFromClock = (hour = 0, minute = 0, second = 0) => {
      const safeHour = Number(hour) || 0;
      const safeMinute = Number(minute) || 0;
      const safeSecond = Number(second) || 0;
      // Create a date object with a fixed date and the specified time
      // This ensures the hour value is used exactly as provided (0-23)
      return finalize(
        dayjs()
          .startOf("day")
          .hour(safeHour)
          .minute(safeMinute)
          .second(safeSecond)
          .millisecond(0),
      );
    };

    if (Array.isArray(value)) {
      if (isDateTimeArray(value)) {
        // Full datetime array: [year, month, day, hour, minute, second, nanoseconds?]
        // When the array has 7 elements (including nanoseconds), it's typically from API/database
        // and represents UTC time. We need to parse as UTC first, then convert to local time.
        const [
          year,
          month = 1,
          day = 1,
          hour = 0,
          minute = 0,
          second = 0,
          nanoseconds,
        ] = value.map((v) => Number(v));

        // If array has 7 elements (includes nanoseconds), treat as UTC from API/database
        // The presence of 7 elements indicates it's from API/database and represents UTC time
        if (value.length === 7) {
          // Parse as UTC, then convert to local time
          return finalize(
            dayjs
              .utc()
              .year(year)
              .month((month || 1) - 1)
              .date(day || 1)
              .hour(hour || 0)
              .minute(minute || 0)
              .second(second || 0)
              .millisecond(0)
              .local(), // Convert UTC to local timezone
          );
        } else {
          // Parse as local time (backend sends 1-indexed months)
          // For arrays with 6 elements (no nanoseconds), assume local time
          return finalize(
            dayjs()
              .year(year)
              .month((month || 1) - 1)
              .date(day || 1)
              .hour(hour || 0)
              .minute(minute || 0)
              .second(second || 0)
              .millisecond(0),
          );
        }
      }

      if (value.length >= 3 && Number(value[0]) > 1000) {
        // Date-only array; cannot extract time
        return null;
      }

      // Time-only array: [hour, minute] or [hour, minute, second]
      // For IV Fluids and other time-only data, treat as local time (not UTC)
      // The backend sends time strings like "15:20:00.000000" which should be local time
      const [hour = 0, minute = 0, second = 0] = value.map(
        (v) => Number(v) || 0,
      );
      return buildFromClock(hour, minute, second);
    }

    if (value instanceof Date) {
      return finalize(dayjs(value));
    }

    if (
      typeof value === "object" &&
      value !== null &&
      ("hour" in value || "minute" in value || "second" in value)
    ) {
      const { hour = 0, minute = 0, second = 0 } = value;
      return buildFromClock(hour, minute, second);
    }

    if (typeof value === "string" || typeof value === "number") {
      const trimmed = String(value).trim();
      if (!trimmed) return null;

      // Check if it's a timestamp (large number representing milliseconds since epoch)
      // Timestamps are typically 13 digits (milliseconds) or 10 digits (seconds)
      const numValue = typeof value === "number" ? value : Number(trimmed);
      if (!isNaN(numValue) && numValue > 1000000000000) {
        // It's a timestamp in milliseconds (UTC)
        // Parse as UTC timestamp and convert to local time
        return finalize(dayjs.utc(numValue).local());
      }

      const twelveHourMatch = trimmed.match(
        /^(\d{1,2}):(\d{2})(?::(\d{2}))?\s?(AM|PM)$/i,
      );
      if (twelveHourMatch) {
        let hour = Number(twelveHourMatch[1]);
        const minute = Number(twelveHourMatch[2]);
        const second = Number(twelveHourMatch[3] || 0);
        const meridiem = twelveHourMatch[4].toUpperCase();
        if (meridiem === "AM" && hour === 12) {
          hour = 0;
        } else if (meridiem === "PM" && hour !== 12) {
          hour += 12;
        }
        return buildFromClock(hour, minute, second);
      }

      // Handle time strings with microseconds: "15:20:00.000000" or "15:20:00"
      const twentyFourHourMatch = trimmed.match(
        /^(\d{1,2}):(\d{2})(?::(\d{2}))?(?:\.\d+)?$/,
      );
      if (twentyFourHourMatch) {
        const hour = Number(twentyFourHourMatch[1]);
        const minute = Number(twentyFourHourMatch[2]);
        const second = Number(twentyFourHourMatch[3] || 0);
        return buildFromClock(hour, minute, second);
      }

      // Try parsing as ISO string or other date formats
      const normalized = trimmed
        .replace(" ", "T")
        .replace(/\.(\d{3})\d+/, ".$1");
      let parsed = dayjs(normalized);
      if (!parsed.isValid() && !normalized.endsWith("Z")) {
        parsed = dayjs(`${normalized}Z`);
      }
      if (!parsed.isValid()) {
        parsed = dayjs(new Date(normalized));
      }
      return finalize(parsed);
    }

    return null;
  };

  const formatTimeValue = (...values) => {
    for (const candidate of values) {
      if (!candidate) continue;

      // Skip date-only arrays (they don't have time information)
      if (Array.isArray(candidate) && !isDateTimeArray(candidate)) {
        if (candidate.length >= 3 && Number(candidate[0]) > 1000) {
          continue; // Date-only array, skip
        }
        // Time-only arrays will be handled by parseTimeValue as UTC
      }

      const parsed = parseTimeValue(candidate);
      if (parsed) {
        // Format the time directly - the hour value is already correct (local time)
        return parsed.format("hh:mm A");
      }
    }
    return "-";
  };

  // Helper function to parse sub-category results
  const parseSubCategoryResults = (result) => {
    if (!result) return null;
    try {
      const parsed = typeof result === "string" ? JSON.parse(result) : result;

      // Handle full format with subCategoryResults
      if (parsed.subCategoryResults) {
        return parsed;
      }

      // Handle compressed format with 's' for subResults and 'r' for remarks
      if (parsed.s || parsed.subResults) {
        const subResultsStr = parsed.s || parsed.subResults || "";
        const subCategoryResults = {};
        if (subResultsStr) {
          subResultsStr.split("|").forEach((item) => {
            const [key, value] = item.split(":");
            if (key && value !== undefined) {
              subCategoryResults[key.trim()] = value.trim();
            }
          });
        }
        return {
          subCategoryResults,
          remarks: parsed.r || parsed.remarks || "",
          testName: parsed.testName || parsed.t || "",
          timestamp: parsed.timestamp || parsed.ts || "",
        };
      }
    } catch (e) {
      // If not JSON, return null
    }
    return null;
  };

  // Helper function to format sub-category results for display
  const formatSubCategoryResults = (result) => {
    const parsed = parseSubCategoryResults(result);
    if (!parsed || !parsed.subCategoryResults) return result;

    const subResults = parsed.subCategoryResults;
    const results = Object.entries(subResults)
      .filter(([key, value]) => value && value.trim() !== "")
      .map(([key, value]) => `${key}: ${value}`)
      .join(", ");

    return results || "No results entered";
  };

  // Helper function to extract remarks from sub-category results
  const extractRemarks = (result) => {
    if (!result) return "";
    const parsed = parseSubCategoryResults(result);
    return parsed?.remarks || parsed?.r || "";
  };

  const getAdmissionBucket = (source, admissionId) =>
    source?.[admissionId] ||
    source?.[String(admissionId)] ||
    source?.[Number(admissionId)] ||
    [];

  const buildIpdSummaryHtml = (admission) => {
    const admissionId = admission?.id;
    const admissionVitals = getAdmissionBucket(vitalList, admissionId);
    const latestVitals =
      admissionVitals.length > 0
        ? admissionVitals[admissionVitals.length - 1]
        : null;
    return buildIpdSummaryDocumentHtml({
      hospitalName,
      hospitalAddress,
      hospitalPhone,
      patient: patientInfo,
      admission,
      assignment:
        AssignmentList[admissionId] ||
        AssignmentList[String(admissionId)] ||
        AssignmentList[Number(admissionId)] ||
        null,
      treatments: getAdmissionBucket(treatmentList, admissionId),
      operations: getAdmissionBucket(operationList, admissionId),
      labTests: getAdmissionBucket(LabtTestList, admissionId),
      consumables: getAdmissionBucket(consumableList, admissionId),
      visits: getAdmissionBucket(visitList, admissionId),
      dischargeList: getAdmissionBucket(dischargeList, admissionId),
      prescriptions: getAdmissionBucket(ipdPrescriptionList, admissionId),
      vitals: latestVitals,
      formatDateFn: (value) => {
        if (Array.isArray(value)) {
          const [year, month, day] = value;
          return dayjs(new Date(year, month - 1, day)).format("DD MMM YYYY");
        }
        return value ? dayjs(value).format("DD MMM YYYY") : "—";
      },
      formatLabResultFn: formatSubCategoryResults,
      formatLabRemarksFn: extractRemarks,
    });
  };

  const exportToPDF = async (admission) => {
    if (!admission?.id) return;
    try {
      await exportPatientSummaryDocumentToPdf({
        bodyHtml: buildIpdSummaryHtml(admission),
        filename: getPatientPdfFilename("ipd_summary", patientId),
      });
    } catch (error) {
      console.error("PDF generation failed", error);
    }
  };

  const handlePrint = (admission) => {
    if (!admission?.id) return;
    printPatientSummaryDocument({
      title: "IPD Summary",
      bodyHtml: buildIpdSummaryHtml(admission),
    });
  };

  // Uses shared catalog so newly added predefined tests (e.g. Semen Analysis) work in report/print.

  const Section = ({ title, children }) => (
    <Box my={4}>
      <Typography variant="h6" fontWeight="bold" gutterBottom>
        {title}
      </Typography>
      {children}
    </Box>
  );

  // Key-Value Table
  const BorderedTable = ({ data }) => (
    <TableContainer component={Paper} variant="outlined">
      <Table size="small">
        <TableBody>
          {Object.entries(data).map(([key, value], idx) => (
            <TableRow key={idx}>
              <StyledHeaderCell>
                {key.replace(/([A-Z])/g, " $1")}
              </StyledHeaderCell>
              <StyledCell>{value}</StyledCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );

  // Styled Cells
  const StyledHeaderCell = (props) => (
    <TableCell
      {...props}
      sx={{
        fontWeight: "bold",
        backgroundColor: "#f0f0f0",
        border: "1px solid #ccc",
        ...props.sx,
      }}
    />
  );

  const formatDateKey = (dateArrayOrString) => {
    if (Array.isArray(dateArrayOrString)) {
      const [year, month, day] = dateArrayOrString;
      return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(
        2,
        "0",
      )}`;
    }
    const date = new Date(dateArrayOrString);
    return date.toISOString().slice(0, 10);
  };

  console.log("AssignmentList:", AssignmentList);

  return (
    <Box sx={{ p: 2 }}>
      <Box display="flex" alignItems="center" mb={2}>
        <IconButton
          onClick={() => (onBack ? onBack() : navigate(-1))}
          sx={{
            left: -25,
            backgroundColor: "#568AF7",
            color: "#fff",
            mr: 1,
            p: 0.5,
            "&:hover": {
              backgroundColor: "#1565c0",
            },
          }}
        >
          <ArrowBackIcon fontSize="small" />
        </IconButton>

        <Typography
          variant="h4"
          fontWeight="bold"
          color="#568AF7"
          sx={{ position: "relative", left: "-25px" }}
        >
          {patientInfo.name?.replace(/\b\w/g, (char) => char.toUpperCase())}{" "}
          Timeline
        </Typography>
      </Box>

      {/* tile heading and time line */}
      <Header />
      {AdmissionList.map((admission, index) => {
        const admissionDate =
          formatAdmissionDateTime(admission) || "Date unknown";
        const admissionPrescriptions = getAdmissionBucket(
          ipdPrescriptionList,
          admission.id,
        );
        const admissionPrescriptionId = resolveAdmissionPrescriptionId(
          admission,
          admissionPrescriptions,
        );
        const admissionKey = `admission-${admission.id}`;
        const activeTab = activeTabs[admissionKey] ?? defaultTimelineTabIndex;

        return (
          <Box
            key={admission.id}
            sx={{ display: "flex", position: "relative" }}
          >
            {/* Timeline column */}
            <Box
              sx={{
                width: "-40px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                position: "relative",
                left: "-20px",
              }}
            >
              {/* Top line (show for all except first item) */}
              {index !== 0 && (
                <Box
                  sx={{
                    width: 2,
                    height: 12,
                    backgroundColor: primaryColor,
                  }}
                />
              )}

              {/* Dot */}
              <Box
                sx={{
                  width: 12,
                  height: 12,
                  borderRadius: "50%",
                  backgroundColor: primaryColor,
                  zIndex: 1,
                }}
              />

              {/* Bottom line (always shown) */}
              <Box
                sx={{
                  width: 2,
                  flexGrow: 1,
                  backgroundColor: primaryColor,
                }}
              />
            </Box>

            {/* Admission content */}
            <Box sx={{ flex: 1, mb: 2.5 }}>
              <Paper elevation={2} sx={{ p: 2 }}>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  sx={{ mb: 1 }}
                >
                  <Box>
                    <Typography
                      variant="body2"
                      fontWeight="bold"
                      sx={{ color: primaryColor }}
                    >
                      {admissionDate}
                    </Typography>
                    <Typography variant="caption" sx={{ color: "text.secondary" }}>
                      Admission ID: {displayId(admission.id)}
                      {"  |  "}
                      Prescription ID: {displayId(admissionPrescriptionId)}
                    </Typography>
                  </Box>
                  <PatientTimelinePrintMenu
                    patientId={patientId}
                    patient={patientInfo}
                    admissionId={admission.id}
                    dateKey={toPeriodDateKey(admission.admissionDate)}
                    onPrintSummary={() => handlePrint(admission)}
                    labReports={getAdmissionBucket(LabtTestList, admission.id)}
                    invoiceTypes={isPharmacyAdmin ? ["MEDICINE"] : null}
                    showLabReports={!isPharmacyAdmin}
                    doctorName={
                      AssignmentList[admission.id]?.doctorName ||
                      AssignmentList[String(admission.id)]?.doctorName ||
                      AssignmentList[admission.id]?.doctor?.name ||
                      AssignmentList[String(admission.id)]?.doctor?.name ||
                      null
                    }
                  />
                </Box>
                <Divider sx={{ mb: 2 }} />
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Typography variant="subtitle1" fontWeight="bold">
                    Patient Record #{index + 1} -{" "}
                    {admission.status.toUpperCase()}
                  </Typography>

                  {/* 3-dot menu */}
                  {/* <IconButton
                    size="small"
                    onClick={(e) => handleMenuOpen(e, admission.id)}
                  >
                    <MoreVertIcon />
                  </IconButton> */}

                  {/* <Menu
                    anchorEl={menuAnchorEls[admission.id]}
                    open={Boolean(menuAnchorEls[admission.id])}
                    onClose={() => handleMenuClose(admission.id)}
                  > */}
                    {/* { admission.status.toLowerCase() !== "discharge" && (
                        <>
                          {(user?.roleName === "doctor" || user?.roleName === "surgeon" || user?.roleName === "staff") && (
                            <>
                              <MenuItem 
                                onClick={() => {
                                  setOpenAsignmentModal(true);
                                  setSelectedAdmissionId(admission.id);
                                  setSelectedPatientId(patientId);
                                  handleClose();
                                }}
                              >
                                + Assignment
                              </MenuItem>
                              
                              <MenuItem
                                onClick={() => {
                                  setOpenTreatmentModal(true);
                                  setSelectedAdmissionId(admission.id);
                                  setSelectedPatientId(patientId);
                                  handleClose();
                                }}
                              >
                                + Treatment & Medicine
                              </MenuItem>

                              <MenuItem 
                                onClick={() => {
                                  setOpenDoctorvisitModal(true);
                                  setSelectedAdmissionId(admission.id);
                                  setSelectedPatientId(patientId);
                                  handleClose();
                                }}
                              >
                                + Doctor/Staff Visits
                              </MenuItem>

                              <MenuItem 
                                onClick={() => {
                                  setOpenConsumableModal(true);
                                  setSelectedAdmissionId(admission.id);
                                  setSelectedPatientId(patientId);
                                  handleClose();
                                }}
                              >
                                + Consumables
                              </MenuItem>

                              <MenuItem 
                                onClick={() => {
                                  setOpenDischargeModal(true);
                                  setSelectedAdmissionId(admission.id);
                                  setSelectedPatientId(patientId);
                                  handleClose();
                                }}
                              >
                                + Discharge Formalities
                              </MenuItem>

                            </>
                          )}

                          {(user?.roleName === "frontdesk" ) && (
                            <>
                              <MenuItem 
                                onClick={() => {
                                  setOpenAsignmentModal(true);
                                  setSelectedAdmissionId(admission.id);
                                  setSelectedPatientId(patientId);
                                  handleClose();
                                }}
                              >
                                + Assignment
                              </MenuItem>
                            </>
                          )}
                        </>
                      )} */}
                    {/* <MenuItem
                      onClick={() => {
                        setOpenDoctorModal(true);
                        setSelectedAdmissionId(admission.id);
                        setSelectedPatientId(patientId);
                        handleClose();
                      }}
                      //onClick={() => setOpenDoctorModal(true)}
                    >
                      View Invoice
                    </MenuItem> */}
                  {/* </Menu> */}
                </Box>
                <Divider sx={{ my: 2 }} />

                <Tabs
                  value={activeTab}
                  onChange={(e, newTab) =>
                    handleTabChange(admissionKey, newTab)
                  }
                  variant="scrollable"
                  scrollButtons="auto"
                  textColor="primary"
                  indicatorColor="primary"
                  sx={{ mb: 2 }}
                >
                  {tabLabels.map((label, i) => (
                    <Tab label={label} key={i} />
                  ))}
                </Tabs>
                <Divider sx={{ mb: 2 }} />

                {activeTab === 0 && (
                  <Table size="small">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: primaryColor }}>
                        <TableCell sx={{ color: "#fff" }}>
                          Patient Name
                        </TableCell>
                        <TableCell sx={{ color: "#fff" }}>Email</TableCell>
                        <TableCell sx={{ color: "#fff" }}>Mobile</TableCell>
                        <TableCell sx={{ color: "#fff" }}>Gender</TableCell>
                        <TableCell sx={{ color: "#fff" }}>Age</TableCell>
                        <TableCell sx={{ color: "#fff" }}>
                          Admission ID
                        </TableCell>
                        <TableCell sx={{ color: "#fff" }}>
                          Prescription ID
                        </TableCell>
                        <TableCell sx={{ color: "#fff" }}>
                          Admission Date & Time
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell>{patientInfo.name}</TableCell>
                        <TableCell>{patientInfo.email}</TableCell>
                        <TableCell>{patientInfo.mobile}</TableCell>
                        <TableCell>{patientInfo.gender}</TableCell>
                        <TableCell>{patientInfo.age}</TableCell>
                        <TableCell>{displayId(admission.id)}</TableCell>
                        <TableCell>
                          {displayId(admissionPrescriptionId)}
                        </TableCell>
                        <TableCell>{admissionDate}</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                )}

                {/* {activeTab === 1 && AssignmentList && (
                    <Table size="small">
                      <TableHead>
                        <TableRow sx={{ backgroundColor: primaryColor }}>
                          <TableCell sx={{ color: "#fff" }}>Admission ID</TableCell>
                          <TableCell sx={{ color: "#fff" }}>Department Name</TableCell>
                          <TableCell sx={{ color: "#fff" }}>Doctor Name</TableCell>
                          <TableCell sx={{ color: "#fff" }}>Staff Name</TableCell>
                          <TableCell sx={{ color: "#fff" }}>Ward</TableCell>
                          <TableCell sx={{ color: "#fff" }}>Bed</TableCell>
                          <TableCell sx={{ color: "#fff" }}>Assigned Date</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {Object.entries(AssignmentList).map(([admissionId, assignment]) => (
                          <TableRow key={admissionId}>
                            <TableCell>{admissionId}</TableCell>
                            <TableCell>{assignment?.departmentName || '-'}</TableCell>
                            <TableCell>{assignment?.doctorName || '-'}</TableCell>
                            <TableCell>{assignment?.nurseName || '-'}</TableCell>
                            <TableCell>{assignment?.wardName || '-'}</TableCell>
                            <TableCell>{assignment?.bedName || '-'}</TableCell>
                            <TableCell>
                              {assignment?.admissionDate
                                ? formatAssignmentDate(assignment.admissionDate).format("DD MMM YYYY")
                                : '-'}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  )} */}

                {activeTab === 1 &&
                  (() => {
                    // Try both number and string keys to handle type mismatches
                    const assignment =
                      AssignmentList[admission.id] ||
                      AssignmentList[String(admission.id)] ||
                      AssignmentList[Number(admission.id)];
                    if (!assignment) {
                      console.log(
                        `No assignment found for admission.id: ${
                          admission.id
                        } (type: ${typeof admission.id})`,
                      );
                      console.log(
                        `Available keys in AssignmentList:`,
                        Object.keys(AssignmentList),
                      );
                      return null;
                    }
                    return (
                      <Table size="small">
                        <TableHead>
                          <TableRow sx={{ backgroundColor: primaryColor }}>
                            <TableCell sx={{ color: "#fff" }}>
                              Department Name
                            </TableCell>
                            <TableCell sx={{ color: "#fff" }}>
                              Doctor Name
                            </TableCell>
                            <TableCell sx={{ color: "#fff" }}>
                              Staff Name
                            </TableCell>
                            <TableCell sx={{ color: "#fff" }}>Ward</TableCell>
                            <TableCell sx={{ color: "#fff" }}>Bed</TableCell>
                            <TableCell sx={{ color: "#fff" }}>
                              Assigned Date
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow>
                            <TableCell>
                              {assignment?.departmentName || "-"}
                            </TableCell>
                            <TableCell>
                              {assignment?.doctorName || "-"}
                            </TableCell>
                            <TableCell>
                              {assignment?.nurseName || "-"}
                            </TableCell>
                            <TableCell>{assignment?.wardName || "-"}</TableCell>
                            <TableCell>{assignment?.bedName || "-"}</TableCell>
                            <TableCell>
                              {assignment?.admissionDate
                                ? formatAssignmentDate(
                                    assignment.admissionDate,
                                  ).format("DD MMM YYYY")
                                : "-"}
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    );
                  })()}

                {activeTab === 2 && (
                  <>
                    {/* Treatment Records View */}
                    <Table size="small">
                      <TableHead>
                        <TableRow sx={{ backgroundColor: primaryColor }}>
                          <TableCell sx={{ color: "#fff" }}>
                            Treatment Type
                          </TableCell>
                          <TableCell sx={{ color: "#fff" }}>Medicine</TableCell>
                          <TableCell sx={{ color: "#fff" }}>Dosage</TableCell>
                          <TableCell sx={{ color: "#fff" }}>
                            Prescribed By
                          </TableCell>
                          <TableCell sx={{ color: "#fff" }}>
                            Performed By
                          </TableCell>
                          <TableCell sx={{ color: "#fff" }}>
                            Prescribed Date
                          </TableCell>
                          <TableCell sx={{ color: "#fff" }}>
                            Prescribed Time
                          </TableCell>
                          <TableCell sx={{ color: "#fff" }}>Remarks</TableCell>
                          {isPharmacyAdmin && (
                            <TableCell sx={{ color: "#fff" }}>Action</TableCell>
                          )}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {(() => {
                          // Try both number and string keys to handle type mismatches
                          const treatments =
                            treatmentList[admission.id] ||
                            treatmentList[String(admission.id)] ||
                            treatmentList[Number(admission.id)] ||
                            [];

                          if (treatments.length === 0) {
                            return (
                              <TableRow>
                                <TableCell colSpan={isPharmacyAdmin ? 9 : 8} align="center">
                                  No treatments available.
                                </TableCell>
                              </TableRow>
                            );
                          }

                          // Get current staff lookup map for fallback enrichment
                          const currentStaffLookup =
                            staffLookup instanceof Map
                              ? staffLookup
                              : new Map();

                          // Try both number and string keys for assignment lookup
                          const assignment =
                            AssignmentList[admission.id] ||
                            AssignmentList[String(admission.id)] ||
                            AssignmentList[Number(admission.id)];

                          return treatments.map((treatment, idx) => {
                            // Fallback enrichment if performedByName is missing
                            let performedByName = treatment.performedByName;
                            if (
                              !performedByName &&
                              treatment.performedBy &&
                              currentStaffLookup.size > 0
                            ) {
                              const staffId = String(treatment.performedBy);
                              performedByName =
                                currentStaffLookup.get(staffId) ||
                                currentStaffLookup.get(
                                  Number(treatment.performedBy),
                                );
                            }

                            return (
                              <TableRow
                                key={`treatment-${treatment.id}-${idx}`}
                              >
                                <TableCell>
                                  {treatment?.treatmentType || "-"}
                                </TableCell>
                                <TableCell>
                                  <Typography variant="body2" fontWeight="bold">
                                    {treatment?.medicine
                                      ? treatment.medicine
                                          .toLowerCase()
                                          .replace(/\b\w/g, (c) =>
                                            c.toUpperCase(),
                                          )
                                      : "-"}
                                  </Typography>
                                </TableCell>
                                <TableCell>
                                  {treatment?.dosage || "-"}
                                </TableCell>
                                <TableCell>
                                  <Typography variant="body2">
                                    {assignment?.doctorName || "-"}
                                  </Typography>
                                </TableCell>
                                <TableCell>
                                  {performedByName ||
                                    treatment.performedBy ||
                                    "-"}
                                </TableCell>
                                <TableCell>
                                  {treatment?.treatmentDate
                                    ? dayjs(treatment.treatmentDate).format(
                                        "DD MMM YYYY",
                                      )
                                    : "-"}
                                </TableCell>
                                <TableCell>
                                  {formatTimeValue(
                                    treatment?.createdAt,
                                    treatment?.prescriptionDate,
                                    isDateTimeArray(treatment?.prescriptionDate)
                                      ? treatment?.prescriptionDate
                                      : null,
                                    treatment?.updatedAt,
                                    treatment?.treatmentTime,
                                  )}
                                </TableCell>
                                <TableCell>
                                  {treatment?.remarks || "-"}
                                </TableCell>
                                {isPharmacyAdmin && (
                                  <TableCell>
                                    {treatment?.medicine ? (
                                      <Button
                                        size="small"
                                        variant="contained"
                                        color="primary"
                                        onClick={() =>
                                          handleIssueMedicine(treatment, admission)
                                        }
                                      >
                                        Issue Medicine
                                      </Button>
                                    ) : (
                                      "-"
                                    )}
                                  </TableCell>
                                )}
                              </TableRow>
                            );
                          });
                        })()}
                      </TableBody>
                    </Table>
                  </>
                )}

                {activeTab === 3 && (
                  <Table size="small">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: primaryColor }}>
                        <TableCell sx={{ color: "#fff" }}>Test Name</TableCell>
                        <TableCell sx={{ color: "#fff" }}>
                          Assigned By
                        </TableCell>
                        <TableCell sx={{ color: "#fff" }}>
                          Assigned To
                        </TableCell>
                        <TableCell sx={{ color: "#fff" }}>
                          Test Result
                        </TableCell>
                        <TableCell sx={{ color: "#fff" }}>Remarks</TableCell>
                        <TableCell sx={{ color: "#fff" }}>
                          Test Status
                        </TableCell>
                        <TableCell sx={{ color: "#fff" }}>
                          Report Date
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {(() => {
                        const labTests = LabtTestList[admission.id] || [];

                        // Get current staff lookup map for enriching labName (fallback enrichment in display)
                        const currentStaffLookup =
                          staffLookup instanceof Map ? staffLookup : new Map();

                        // Enrich lab tests with labName from staff lookup (fallback if not enriched during fetch)
                        const enrichedLabTests = labTests.map((lab) => {
                          // Create a copy to avoid mutating the original
                          const enrichedLab = { ...lab };

                          // Enrich labName from labId (path desk staff ID) if not already enriched
                          if (
                            enrichedLab.labId &&
                            currentStaffLookup.size > 0
                          ) {
                            const staffId = String(enrichedLab.labId);
                            const staffName =
                              currentStaffLookup.get(staffId) ||
                              currentStaffLookup.get(Number(enrichedLab.labId));
                            if (
                              staffName &&
                              (!enrichedLab.labName ||
                                enrichedLab.labName.trim() === "")
                            ) {
                              enrichedLab.labName = staffName;
                            }
                          }

                          return enrichedLab;
                        });

                        // Deduplication: Use record ID first, then fall back to testName + testDate
                        const uniqueLabTestsMap = new Map();
                        const seenIds = new Set(); // Track seen record IDs to prevent exact duplicates

                        enrichedLabTests.forEach((lab) => {
                          // First, check if we've seen this exact record ID (exact duplicate)
                          if (lab.id !== null && lab.id !== undefined) {
                            if (seenIds.has(lab.id)) {
                              return; // Skip exact duplicate
                            }
                            seenIds.add(lab.id);
                          }

                          // Normalize test name (trim and lowercase for comparison)
                          const normalizedTestName = (lab.testName || "")
                            .toString()
                            .trim()
                            .toLowerCase();
                          const testId = lab.testId || normalizedTestName;

                          // Normalize test date for consistent comparison
                          let normalizedDateStr = "";
                          if (lab.testDate) {
                            if (Array.isArray(lab.testDate)) {
                              normalizedDateStr = JSON.stringify(lab.testDate);
                            } else {
                              // Convert to string and normalize
                              normalizedDateStr = String(lab.testDate).trim();
                            }
                          }

                          // Create unique key based on normalized testId/testName + normalized testDate
                          const uniqueKey = `${testId}-${normalizedDateStr}`;

                          // Check if we already have this test for this date
                          if (uniqueLabTestsMap.has(uniqueKey)) {
                            const existingLab =
                              uniqueLabTestsMap.get(uniqueKey);

                            // Prefer the record with more complete information
                            const existingScore =
                              (existingLab.testResult ? 2 : 0) +
                              (existingLab.labName ? 1 : 0) +
                              (existingLab.id ? 1 : 0);
                            const currentScore =
                              (lab.testResult ? 2 : 0) +
                              (lab.labName ? 1 : 0) +
                              (lab.id ? 1 : 0);

                            // Keep the one with more complete info, or the one with higher id if scores are equal
                            if (
                              currentScore > existingScore ||
                              (currentScore === existingScore &&
                                (lab.id || 0) > (existingLab.id || 0))
                            ) {
                              uniqueLabTestsMap.set(uniqueKey, lab);
                            }
                          } else {
                            // First occurrence of this testId + testDate combination
                            uniqueLabTestsMap.set(uniqueKey, lab);
                          }
                        });

                        const uniqueLabTests = Array.from(
                          uniqueLabTestsMap.values(),
                        );

                        if (uniqueLabTests.length === 0) {
                          return (
                            <TableRow>
                              <TableCell colSpan={7} align="center">
                                No Lab Tests available.
                              </TableCell>
                            </TableRow>
                          );
                        }

                        return uniqueLabTests.map((lab, idx) => (
                          <TableRow
                            key={
                              lab.id ||
                              `lab-${idx}-${
                                lab.resolvedTestName || lab.testName
                              }-${lab.testDate}`
                            }
                          >
                            <TableCell>
                              {lab.resolvedTestName || lab.testName || "N/A"}
                            </TableCell>
                            <TableCell>
                              <Typography variant="body2">
                                {AssignmentList[admission.id]?.doctorName ||
                                  "-"}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              {lab.labName
                                ? `Path: ${lab.labName
                                    .charAt(0)
                                    .toUpperCase()}${lab.labName.slice(1)}`
                                : lab.labId
                                ? `Path Desk Staff ID: ${lab.labId}`
                                : "-"}
                            </TableCell>
                            <TableCell>
                              <Box
                                sx={{ maxWidth: 300, wordBreak: "break-word" }}
                              >
                                {formatSubCategoryResults(lab.testResult)}
                              </Box>
                            </TableCell>
                            <TableCell>
                              <Box
                                sx={{ maxWidth: 200, wordBreak: "break-word" }}
                              >
                                {extractRemarks(lab.testResult)}
                              </Box>
                            </TableCell>
                            <TableCell>
                              {lab.testStatus === "COMPLETED"
                                ? "COMPLETE"
                                : lab.testStatus}
                            </TableCell>
                            <TableCell>
                              {lab.testDate
                                ? formatLabTestDate(lab.testDate).format(
                                    "DD MMM YYYY",
                                  )
                                : "-"}
                            </TableCell>
                          </TableRow>
                        ));
                      })()}
                    </TableBody>
                  </Table>
                )}

                {activeTab === 4 && (
                  <Table size="small">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: primaryColor }}>
                        <TableCell sx={{ color: "#fff" }}>
                          Operation Name
                        </TableCell>
                        <TableCell sx={{ color: "#fff" }}>
                          Operation Date
                        </TableCell>
                        <TableCell sx={{ color: "#fff" }}>
                          Operation Time
                        </TableCell>
                        <TableCell sx={{ color: "#fff" }}>
                          Operation Status
                        </TableCell>
                        <TableCell sx={{ color: "#fff" }}>
                          Doctor/Surgeon
                        </TableCell>
                        <TableCell sx={{ color: "#fff" }}>Staff</TableCell>
                        <TableCell sx={{ color: "#fff" }}>
                          Anesthologist
                        </TableCell>
                        <TableCell sx={{ color: "#fff" }}>Pre Notes</TableCell>
                        <TableCell sx={{ color: "#fff" }}>Post Notes</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {(operationList[admission.id] || []).length === 0 ? (
                        <TableRow>
                          <TableCell colSpan={9} align="center">
                            No operation & surgeries available.
                          </TableCell>
                        </TableRow>
                      ) : (
                        (operationList[admission.id] || []).map(
                          (treatment, idx) => {
                            // Format operation time
                            let formattedTime = "-";
                            if (treatment.operationTime) {
                              if (
                                Array.isArray(treatment.operationTime) &&
                                treatment.operationTime.length >= 2
                              ) {
                                // Array format: [hour, minute]
                                const hour =
                                  Number(treatment.operationTime[0]) || 0;
                                const minute =
                                  Number(treatment.operationTime[1]) || 0;
                                formattedTime = dayjs()
                                  .hour(hour)
                                  .minute(minute)
                                  .second(0)
                                  .format("hh:mm A");
                              } else if (
                                typeof treatment.operationTime === "string"
                              ) {
                                // String format: "HH:mm"
                                const [hour, minute] = treatment.operationTime
                                  .split(":")
                                  .map(Number);
                                if (!isNaN(hour) && !isNaN(minute)) {
                                  formattedTime = dayjs()
                                    .hour(hour)
                                    .minute(minute)
                                    .second(0)
                                    .format("hh:mm A");
                                }
                              }
                            }

                            return (
                              <TableRow key={idx}>
                                <TableCell>
                                  {treatment.operationName || "-"}
                                </TableCell>
                                <TableCell>
                                  {treatment.operationDate
                                    ? Array.isArray(treatment.operationDate)
                                      ? dayjs(
                                          new Date(
                                            treatment.operationDate[0],
                                            treatment.operationDate[1] - 1,
                                            treatment.operationDate[2],
                                          ),
                                        ).format("DD MMM YYYY")
                                      : dayjs(treatment.operationDate).format(
                                          "DD MMM YYYY",
                                        )
                                    : "-"}
                                </TableCell>
                                <TableCell>{formattedTime}</TableCell>
                                <TableCell>
                                  {treatment.operationStatus || "-"}
                                </TableCell>
                                <TableCell>
                                  {treatment.surgeonName || "-"}
                                </TableCell>
                                <TableCell>
                                  {treatment.nurseNames || "-"}
                                </TableCell>
                                <TableCell>
                                  {treatment.anesthetistName || "-"}
                                </TableCell>
                                <TableCell>
                                  {treatment.preOpNotes || "-"}
                                </TableCell>
                                <TableCell>
                                  {treatment.postOpNotes || "-"}
                                </TableCell>
                              </TableRow>
                            );
                          },
                        )
                      )}
                    </TableBody>
                  </Table>
                )}

                {activeTab === 5 && (
                  <Table size="small">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: primaryColor }}>
                        <TableCell sx={{ color: "#fff" }}>
                          Resource Name
                        </TableCell>
                        <TableCell sx={{ color: "#fff" }}>Quantity</TableCell>
                        <TableCell sx={{ color: "#fff" }}>Used By</TableCell>
                        <TableCell sx={{ color: "#fff" }}>Used on</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {(consumableList[admission.id] || []).length === 0 ? (
                        <TableRow>
                          <TableCell colSpan={5} align="center">
                            No Consumables found.
                          </TableCell>
                        </TableRow>
                      ) : (
                        (consumableList[admission.id] || []).map(
                          (consumable, idx) => {
                            // Get current staff lookup map for fallback enrichment
                            const currentStaffLookup =
                              staffLookup instanceof Map
                                ? staffLookup
                                : new Map();

                            // Fallback enrichment if usedByName is missing
                            let usedByName = consumable.usedByName;
                            if (
                              !usedByName &&
                              consumable.usedBy &&
                              currentStaffLookup.size > 0
                            ) {
                              const staffId = String(consumable.usedBy);
                              usedByName =
                                currentStaffLookup.get(staffId) ||
                                currentStaffLookup.get(
                                  Number(consumable.usedBy),
                                );
                            }
                            if (!usedByName && consumable.usedBy) {
                              usedByName = String(consumable.usedBy);
                            }

                            return (
                              <TableRow key={idx}>
                                <TableCell>
                                  {consumable.resourceName ||
                                    consumable.name ||
                                    consumable.itemName ||
                                    "-"}
                                </TableCell>
                                <TableCell>
                                  {consumable.quantity || "-"}
                                </TableCell>
                                <TableCell>{usedByName || "-"}</TableCell>
                                <TableCell>
                                  {consumable.dateUsed
                                    ? Array.isArray(consumable.dateUsed) &&
                                      consumable.dateUsed.length >= 3
                                      ? dayjs(
                                          new Date(
                                            consumable.dateUsed[0],
                                            consumable.dateUsed[1] - 1,
                                            consumable.dateUsed[2],
                                          ),
                                        ).format("DD MMM YYYY")
                                      : dayjs(consumable.dateUsed).format(
                                          "DD MMM YYYY",
                                        )
                                    : "-"}
                                </TableCell>
                              </TableRow>
                            );
                          },
                        )
                      )}
                    </TableBody>
                  </Table>
                )}

                {activeTab === 6 && (
                  <Table size="small">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: primaryColor }}>
                        <TableCell sx={{ color: "#fff" }}>Visit Type</TableCell>
                        <TableCell sx={{ color: "#fff" }}>Visited By</TableCell>
                        <TableCell sx={{ color: "#fff" }}>Visited At</TableCell>
                        <TableCell sx={{ color: "#fff" }}>Notes</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {(visitList[admission.id] || []).length === 0 ? (
                        <TableRow>
                          <TableCell colSpan={5} align="center">
                            No visit record available.
                          </TableCell>
                        </TableRow>
                      ) : (
                        (visitList[admission.id] || []).map(
                          (treatment, idx) => {
                            // Get current staff lookup map for fallback enrichment
                            const currentStaffLookup =
                              staffLookup instanceof Map
                                ? staffLookup
                                : new Map();

                            // Resolve visitedByName with fallback
                            let visitedByName = treatment.visitedByName;
                            if (!visitedByName && treatment.visitedBy) {
                              if (treatment.visitType === "doctor") {
                                // Try assignment first
                                const assignment =
                                  AssignmentList[admission.id] ||
                                  AssignmentList[String(admission.id)] ||
                                  AssignmentList[Number(admission.id)];
                                if (
                                  assignment &&
                                  assignment.doctorId === treatment.visitedBy
                                ) {
                                  visitedByName = assignment.doctorName;
                                } else {
                                  // Fallback: try to fetch doctor
                                  visitedByName = String(treatment.visitedBy);
                                }
                              } else {
                                // For staff visits, use staff lookup
                                if (currentStaffLookup.size > 0) {
                                  const staffId = String(treatment.visitedBy);
                                  const staffName =
                                    currentStaffLookup.get(staffId) ||
                                    currentStaffLookup.get(
                                      Number(treatment.visitedBy),
                                    );
                                  if (staffName) {
                                    visitedByName = staffName;
                                  } else {
                                    visitedByName = String(treatment.visitedBy);
                                  }
                                } else {
                                  // Fallback: try assignment's nurse list
                                  const assignment =
                                    AssignmentList[admission.id] ||
                                    AssignmentList[String(admission.id)] ||
                                    AssignmentList[Number(admission.id)];
                                  if (assignment && assignment.nurseId) {
                                    const ids = String(assignment.nurseId || "")
                                      .split(",")
                                      .map((s) => s.trim());
                                    const names = String(
                                      assignment.nurseName || "",
                                    )
                                      .split(",")
                                      .map((s) => s.trim());
                                    const idx = ids.findIndex(
                                      (id) =>
                                        String(id) ===
                                        String(treatment.visitedBy),
                                    );
                                    visitedByName =
                                      idx >= 0
                                        ? names[idx] ||
                                          String(treatment.visitedBy)
                                        : String(treatment.visitedBy);
                                  } else {
                                    visitedByName = String(treatment.visitedBy);
                                  }
                                }
                              }
                            }

                            return (
                              <TableRow key={idx}>
                                <TableCell>
                                  {treatment?.visitType
                                    ? treatment.visitType
                                        .toLowerCase()
                                        .replace(/\b\w/g, (c) =>
                                          c.toUpperCase(),
                                        )
                                    : "-"}
                                </TableCell>
                                <TableCell>{visitedByName || "-"}</TableCell>
                                <TableCell>
                                  {Array.isArray(treatment.visitDate) &&
                                  treatment.visitDate.length > 0
                                    ? (() => {
                                        // Backend sends 1-indexed months, but JavaScript Date expects 0-indexed months
                                        const [year, month, day, ...rest] =
                                          treatment.visitDate;
                                        return dayjs(
                                          new Date(
                                            year,
                                            month - 1,
                                            day,
                                            ...rest,
                                          ),
                                        ).format("DD MMM YYYY");
                                      })()
                                    : treatment.visitDate
                                    ? dayjs(treatment.visitDate).format(
                                        "DD MMM YYYY",
                                      )
                                    : "-"}
                                </TableCell>
                                <TableCell>{treatment.notes || "-"}</TableCell>
                              </TableRow>
                            );
                          },
                        )
                      )}
                    </TableBody>
                  </Table>
                )}

                {activeTab === 7 && (
                  <Box p={3}>
                    <Paper
                      elevation={3}
                      sx={{
                        padding: 4,
                        maxHeight: "80vh", // Limits height
                        overflowY: "auto", // Enables vertical scroll
                      }}
                      ref={reportRef}
                    >
                      <Typography
                        variant="h4"
                        gutterBottom
                        align="center"
                        fontWeight="bold"
                      >
                        Nurse Notes
                      </Typography>

                      <Section title="Patient Demographics">
                        {(() => {
                          // Try both number and string keys to handle type mismatches
                          const assignment =
                            AssignmentList[admission.id] ||
                            AssignmentList[String(admission.id)] ||
                            AssignmentList[Number(admission.id)];
                          return assignment ? (
                            <Table size="small">
                              <TableHead>
                                <TableRow
                                  sx={{ backgroundColor: primaryColor }}
                                >
                                  <TableCell sx={{ color: "#fff" }}>
                                    Department Name
                                  </TableCell>
                                  <TableCell sx={{ color: "#fff" }}>
                                    Doctor Name
                                  </TableCell>
                                  <TableCell sx={{ color: "#fff" }}>
                                    Staff Name
                                  </TableCell>
                                  <TableCell sx={{ color: "#fff" }}>
                                    Ward
                                  </TableCell>
                                  <TableCell sx={{ color: "#fff" }}>
                                    Bed
                                  </TableCell>
                                  <TableCell sx={{ color: "#fff" }}>
                                    Assigned Date
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                <TableRow>
                                  <TableCell>
                                    {assignment?.departmentName || "-"}
                                  </TableCell>
                                  <TableCell>
                                    {assignment?.doctorName || "-"}
                                  </TableCell>
                                  <TableCell>
                                    {assignment?.nurseName || "-"}
                                  </TableCell>
                                  <TableCell>
                                    {assignment?.wardName || "-"}
                                  </TableCell>
                                  <TableCell>
                                    {assignment?.bedName || "-"}
                                  </TableCell>
                                  <TableCell>
                                    {assignment?.admissionDate
                                      ? formatAssignmentDate(
                                          assignment.admissionDate,
                                        ).format("DD MMM YYYY")
                                      : "-"}
                                  </TableCell>
                                </TableRow>
                              </TableBody>
                            </Table>
                          ) : (
                            <Typography variant="body2" sx={{ px: 2, py: 1 }}>
                              No assignment found for this admission.
                            </Typography>
                          );
                        })()}
                      </Section>

                      {/* Treatments */}
                      <Section title="Medical History">
                        <Table size="small">
                          <TableHead>
                            <TableRow sx={{ backgroundColor: primaryColor }}>
                              <TableCell sx={{ color: "#fff" }}>
                                Nurse Name
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Past Medical History
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Past Surgical History
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Allergies
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Fall Risk / Seizure Risk
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Infection Precautions
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Created At
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {(HistoryList[admission.id] || []).length === 0 ? (
                              <TableRow>
                                <TableCell colSpan={7} align="center">
                                  No Medical Hitory Found.
                                </TableCell>
                              </TableRow>
                            ) : (
                              HistoryList[admission.id].map(
                                (treatment, idx) => (
                                  <TableRow key={idx}>
                                    <TableCell>{treatment.nurseName}</TableCell>
                                    <TableCell>
                                      {treatment.pastMedicalHistory}
                                    </TableCell>
                                    <TableCell>
                                      {treatment.pastSurgicalHistory}
                                    </TableCell>
                                    <TableCell>{treatment.allergies}</TableCell>
                                    <TableCell>
                                      {treatment.fallOrSeizureRisk}
                                    </TableCell>
                                    <TableCell>
                                      {treatment.infectionPrecautions}
                                    </TableCell>
                                    <TableCell>
                                      {dayjs(treatment.treatmentDate).format(
                                        "DD MMM YYYY",
                                      )}
                                    </TableCell>
                                  </TableRow>
                                ),
                              )
                            )}
                          </TableBody>
                        </Table>
                      </Section>

                      {/* Lab Tests */}
                      <Section title="Vital Signs Monitoring">
                        <Table size="small">
                          <TableHead>
                            <TableRow sx={{ backgroundColor: primaryColor }}>
                              <TableCell sx={{ color: "#fff" }}>
                                Nurse Name
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>BP</TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Temperature
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Heart Rate
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Respiratory Rate
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>SpO2</TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Pain Score
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                GCS (if applicable)
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {(vitalList[admission.id] || []).length === 0 ? (
                              <TableRow>
                                <TableCell colSpan={8} align="center">
                                  No Vital Signs Record Available
                                </TableCell>
                              </TableRow>
                            ) : (
                              vitalList[admission.id].map((lab, idx) => (
                                <TableRow key={idx}>
                                  <TableCell>{lab.nurseName}</TableCell>
                                  <TableCell>{lab.bp}</TableCell>
                                  <TableCell>{lab.temperature}</TableCell>
                                  <TableCell>{lab.heartRate}</TableCell>
                                  <TableCell>{lab.respiratoryRate}</TableCell>
                                  <TableCell>{lab.spo2}</TableCell>
                                  <TableCell>{lab.painScore || `0`}</TableCell>
                                  <TableCell>{lab.gcsScore || `0`}</TableCell>
                                </TableRow>
                              ))
                            )}
                          </TableBody>
                        </Table>
                      </Section>

                      {/* Operation & Surgeries */}
                      <Section title="Medications">
                        <Table size="small">
                          <TableHead>
                            <TableRow sx={{ backgroundColor: primaryColor }}>
                              <TableCell sx={{ color: "#fff" }}>
                                Administered by
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>Date</TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Notes
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Medicine Name
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Quantity used
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                {" "}
                                Time
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {(() => {
                              const medications =
                                patientMedicineInventory[admission.id] ||
                                patientMedicineInventory[
                                  String(admission.id)
                                ] ||
                                [];

                            

                              if (medications.length === 0) {
                                return (
                                  <TableRow>
                                    <TableCell colSpan={7} align="center">
                                      No medications available.
                                    </TableCell>
                                  </TableRow>
                                );
                              }
                              console.log(patientMedicineInventory);

                              return medications.map((med) => (
                                <TableRow key={med.id}>
                                  {/* Nurse Name */}
                                  <TableCell>
                                    {med?.administeredBy || "-"}
                                  </TableCell>

                                  {/* Date & Time */}
                                  <TableCell>
                                    {formatDate(med.administeredDate)}
                                  </TableCell>

                                  {/* Notes */}
                                  <TableCell>{med?.notes || "-"}</TableCell>

                                  {/* Medicine */}
                                  <TableCell>
                                    <Typography fontWeight="bold">
                                      {med?.medicineName
                                        ? med.medicineName
                                            .toLowerCase()
                                            .replace(/\b\w/g, (c) =>
                                              c.toUpperCase(),
                                            )
                                        : "-"}
                                    </Typography>
                                  </TableCell>

                                  {/* Quantity */}
                                  <TableCell>{med?.quantity || "-"}</TableCell>

                                  {/* Time */}
                                  <TableCell>
                                    {formatTime(med.createdAt)}
                                  </TableCell>
                                </TableRow>
                              ));
                            })()}
                          </TableBody>
                        </Table>
                      </Section>

                      {/* Resources & Consumables */}
                      <Section title="IV Fluids">
                        <Table size="small">
                          <TableHead>
                            <TableRow sx={{ backgroundColor: primaryColor }}>
                              <TableCell sx={{ color: "#fff" }}>
                                Nurse Name
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>Type</TableCell>
                              <TableCell sx={{ color: "#fff" }}>Rate</TableCell>
                              <TableCell sx={{ color: "#fff" }}>Site</TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Start Time
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {(FluidList[admission.id] || []).length === 0 ? (
                              <TableRow>
                                <TableCell colSpan={5} align="center">
                                  No IV Fluids Record Found.
                                </TableCell>
                              </TableRow>
                            ) : (
                              FluidList[admission.id].map((treatment, idx) => (
                                <TableRow key={idx}>
                                  <TableCell>{treatment.nurseName}</TableCell>
                                  <TableCell>{treatment.fluidType}</TableCell>
                                  <TableCell>{treatment.rate}</TableCell>
                                  <TableCell>{treatment.site}</TableCell>
                                  <TableCell>
                                    {formatTimeValue(
                                      treatment.startTime,
                                      treatment?.createdAt,
                                      isDateTimeArray(treatment?.startTime)
                                        ? treatment?.startTime
                                        : null,
                                    )}
                                  </TableCell>
                                </TableRow>
                              ))
                            )}
                          </TableBody>
                        </Table>
                      </Section>

                      {/* Doctor Visits */}
                      <Section title="Nutrition / Diet Plan">
                        <Table size="small">
                          <TableHead>
                            <TableRow sx={{ backgroundColor: primaryColor }}>
                              <TableCell sx={{ color: "#fff" }}>
                                Nurse Name
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Diet Type
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Feeding Method
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Fluid Restriction
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {(nutritionList[admission.id] || []).length ===
                            0 ? (
                              <TableRow>
                                <TableCell colSpan={4} align="center">
                                  No Nutrition Plan Record Available.
                                </TableCell>
                              </TableRow>
                            ) : (
                              nutritionList[admission.id].map(
                                (treatment, idx) => (
                                  <TableRow key={idx}>
                                    <TableCell>{treatment.nurseName}</TableCell>
                                    <TableCell>{treatment.dietType}</TableCell>
                                    <TableCell>
                                      {treatment.feedingMethod}
                                    </TableCell>
                                    <TableCell>
                                      {treatment.fluidRestriction}
                                    </TableCell>
                                  </TableRow>
                                ),
                              )
                            )}
                          </TableBody>
                        </Table>
                      </Section>

                      {/* Discharge Formalities */}
                      <Section title="Elimination / Output">
                        <Table size="small">
                          <TableHead>
                            <TableRow sx={{ backgroundColor: primaryColor }}>
                              <TableCell sx={{ color: "#fff" }}>
                                Nurse Name
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Urine
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Vomiting / Drains
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Stool
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {(eliminationList[admission.id] || []).length ===
                            0 ? (
                              <TableRow>
                                <TableCell colSpan={7} align="center">
                                  No Elimination Record Available.
                                </TableCell>
                              </TableRow>
                            ) : (
                              eliminationList[admission.id].map(
                                (discharge, idx) => (
                                  <TableRow key={idx}>
                                    <TableCell>{discharge.nurseName}</TableCell>
                                    <TableCell>{discharge.urine}</TableCell>
                                    <TableCell>
                                      {discharge.vomitingOrDrains}
                                    </TableCell>
                                    <TableCell>{discharge.stool}</TableCell>
                                  </TableRow>
                                ),
                              )
                            )}
                          </TableBody>
                        </Table>
                      </Section>

                      <Section title="Investigations">
                        <Table size="small">
                          <TableHead>
                            <TableRow sx={{ backgroundColor: primaryColor }}>
                              <TableCell sx={{ color: "#fff" }}>
                                Nurse Name
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Test Name
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Status
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Important Results
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Created At
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {(investigationList[admission.id] || []).length ===
                            0 ? (
                              <TableRow>
                                <TableCell colSpan={7} align="center">
                                  No Investigation Record Available.
                                </TableCell>
                              </TableRow>
                            ) : (
                              investigationList[admission.id].map(
                                (investigation, idx) => (
                                  <TableRow key={idx}>
                                    <TableCell>
                                      {investigation.nurseName}
                                    </TableCell>
                                    <TableCell>
                                      {investigation.resolvedTestName ||
                                        investigation.testName ||
                                        "N/A"}
                                    </TableCell>
                                    <TableCell>
                                      {investigation.status}
                                    </TableCell>
                                    <TableCell>
                                      {investigation.importantResults}
                                    </TableCell>
                                    <TableCell>
                                      {dayjs(investigation.createdAt).format(
                                        "DD/MM/YYYY hh:mm A",
                                      )}
                                    </TableCell>
                                  </TableRow>
                                ),
                              )
                            )}
                          </TableBody>
                        </Table>
                      </Section>

                      <Section title="Nursing Care Plan">
                        <Table size="small">
                          <TableHead>
                            <TableRow sx={{ backgroundColor: primaryColor }}>
                              <TableCell sx={{ color: "#fff" }}>
                                Nurse Name
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Problem
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Intervention
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>Goal</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {(careList[admission.id] || []).length === 0 ? (
                              <TableRow>
                                <TableCell colSpan={7} align="center">
                                  No Nursing Care Record Available.
                                </TableCell>
                              </TableRow>
                            ) : (
                              careList[admission.id].map((discharge, idx) => (
                                <TableRow key={idx}>
                                  <TableCell>{discharge.nurseName}</TableCell>
                                  <TableCell>{discharge.problem}</TableCell>
                                  <TableCell>
                                    {discharge.intervention}
                                  </TableCell>
                                  <TableCell>{discharge.goal}</TableCell>
                                </TableRow>
                              ))
                            )}
                          </TableBody>
                        </Table>
                      </Section>

                      <Section title="Devices / Procedures">
                        <Table size="small">
                          <TableHead>
                            <TableRow sx={{ backgroundColor: primaryColor }}>
                              <TableCell sx={{ color: "#fff" }}>
                                Nurse Name
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                IV Lines
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Catheters
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Tubes
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Drain Sites
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {(procedureList[admission.id] || []).length ===
                            0 ? (
                              <TableRow>
                                <TableCell colSpan={7} align="center">
                                  No Procedure Record Available.
                                </TableCell>
                              </TableRow>
                            ) : (
                              procedureList[admission.id].map(
                                (discharge, idx) => (
                                  <TableRow key={idx}>
                                    <TableCell>{discharge.nurseName}</TableCell>
                                    <TableCell>{discharge.ivLines}</TableCell>
                                    <TableCell>{discharge.catheters}</TableCell>
                                    <TableCell>{discharge.tubes}</TableCell>
                                    <TableCell>
                                      {discharge.drainSites}
                                    </TableCell>
                                  </TableRow>
                                ),
                              )
                            )}
                          </TableBody>
                        </Table>
                      </Section>

                      <Section title="Activity / Mobility">
                        <Table size="small">
                          <TableHead>
                            <TableRow sx={{ backgroundColor: primaryColor }}>
                              <TableCell sx={{ color: "#fff" }}>
                                Nurse Name
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Mobility Level
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Turning Schedule
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Fall Risk Precautions
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {(mobilityList[admission.id] || []).length === 0 ? (
                              <TableRow>
                                <TableCell colSpan={7} align="center">
                                  No Activity / Mobility Record available.
                                </TableCell>
                              </TableRow>
                            ) : (
                              mobilityList[admission.id].map(
                                (discharge, idx) => (
                                  <TableRow key={idx}>
                                    <TableCell>{discharge.nurseName}</TableCell>
                                    <TableCell>
                                      {discharge.mobilityLevel}
                                    </TableCell>
                                    <TableCell>
                                      {discharge.turningSchedule}
                                    </TableCell>
                                    <TableCell>
                                      {discharge.fallRiskPrecautions}
                                    </TableCell>
                                  </TableRow>
                                ),
                              )
                            )}
                          </TableBody>
                        </Table>
                      </Section>

                      <Section title="Shift-wise Nursing Notes">
                        <Table size="small">
                          <TableHead>
                            <TableRow sx={{ backgroundColor: primaryColor }}>
                              <TableCell sx={{ color: "#fff" }}>
                                Nurse Name
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Observations
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Shift
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {(notesList[admission.id] || []).length === 0 ? (
                              <TableRow>
                                <TableCell colSpan={7} align="center">
                                  No Nurse Notes Available.
                                </TableCell>
                              </TableRow>
                            ) : (
                              notesList[admission.id].map((discharge, idx) => (
                                <TableRow key={idx}>
                                  <TableCell>{discharge.nurseName}</TableCell>
                                  <TableCell>
                                    {discharge.observationsInterventions}
                                  </TableCell>
                                  <TableCell>{discharge.shift}</TableCell>
                                </TableRow>
                              ))
                            )}
                          </TableBody>
                        </Table>
                      </Section>

                      <Section title="Patient Education & Communication">
                        <Table size="small">
                          <TableHead>
                            <TableRow sx={{ backgroundColor: primaryColor }}>
                              <TableCell sx={{ color: "#fff" }}>
                                Nurse Name
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Education Provided
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Family Counseling
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {(communicationList[admission.id] || []).length ===
                            0 ? (
                              <TableRow>
                                <TableCell colSpan={7} align="center">
                                  No Patient Communication Record Available.
                                </TableCell>
                              </TableRow>
                            ) : (
                              communicationList[admission.id].map(
                                (discharge, idx) => (
                                  <TableRow key={idx}>
                                    <TableCell>{discharge.nurseName}</TableCell>
                                    <TableCell>
                                      {discharge.educationProvided}
                                    </TableCell>
                                    <TableCell>
                                      {discharge.familyCounseling}
                                    </TableCell>
                                  </TableRow>
                                ),
                              )
                            )}
                          </TableBody>
                        </Table>
                      </Section>

                      <Section title="Miscellaneous / Alerts">
                        <Table size="small">
                          <TableHead>
                            <TableRow sx={{ backgroundColor: primaryColor }}>
                              <TableCell sx={{ color: "#fff" }}>
                                Nurse Name
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Special Notes
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>DNR</TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Discharge Plans
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {(miscAlertList[admission.id] || []).length ===
                            0 ? (
                              <TableRow>
                                <TableCell colSpan={7} align="center">
                                  No Misc Alerts Available.
                                </TableCell>
                              </TableRow>
                            ) : (
                              miscAlertList[admission.id].map(
                                (discharge, idx) => (
                                  <TableRow key={idx}>
                                    <TableCell>{discharge.nurseName}</TableCell>
                                    <TableCell>
                                      {discharge.specialNotes}
                                    </TableCell>
                                    <TableCell>{discharge.dnr}</TableCell>
                                    <TableCell>
                                      {discharge.dischargePlans}
                                    </TableCell>
                                  </TableRow>
                                ),
                              )
                            )}
                          </TableBody>
                        </Table>
                      </Section>
                    </Paper>
                  </Box>
                )}

                {activeTab === 8 && (
                  <Table size="small">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: primaryColor }}>
                        <TableCell sx={{ color: "#fff" }}>
                          Discharge Date
                        </TableCell>
                        <TableCell sx={{ color: "#fff" }}>
                          Discharge Time
                        </TableCell>
                        <TableCell sx={{ color: "#fff" }}>
                          Discharge Type
                        </TableCell>
                        <TableCell sx={{ color: "#fff" }}>
                          Final Diagnose
                        </TableCell>
                        <TableCell sx={{ color: "#fff" }}>
                          Follow up Advice
                        </TableCell>
                        <TableCell sx={{ color: "#fff" }}>
                          Condition On Discharge
                        </TableCell>
                        <TableCell sx={{ color: "#fff" }}>Remarks</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {(dischargeList[admission.id] || []).length === 0 ? (
                        <TableRow>
                          <TableCell colSpan={7} align="center">
                            No Discharge Record Available.
                          </TableCell>
                        </TableRow>
                      ) : (
                        (dischargeList[admission.id] || []).map(
                          (treatment, idx) => (
                            <TableRow key={idx}>
                              <TableCell>
                                {Array.isArray(treatment.dischargeDate) &&
                                treatment.dischargeDate.length > 0
                                  ? dayjs(
                                      new Date(...treatment.dischargeDate),
                                    ).format("DD MMM YYYY")
                                  : treatment.dischargeDate
                                  ? dayjs(treatment.dischargeDate).format(
                                      "DD MMM YYYY",
                                    )
                                  : "-"}
                              </TableCell>
                              <TableCell>
                                {dayjs()
                                  .hour(treatment.dischargeTime[0])
                                  .minute(treatment.dischargeTime[1])
                                  .format("hh:mm A")}
                              </TableCell>
                              <TableCell>
                                {treatment.dischargeType ||
                                  treatment.dischargeType}
                              </TableCell>
                              <TableCell>
                                {treatment.finalDiagnose ||
                                  treatment.finalDiagnose}
                              </TableCell>
                              <TableCell>
                                {treatment.followUpAdvice ||
                                  treatment.followUpAdvice}
                              </TableCell>
                              <TableCell>
                                {treatment.conditionOnDischarge ||
                                  treatment.conditionOnDischarge}
                              </TableCell>
                              <TableCell>
                                {treatment.remarks || treatment.remarks}
                              </TableCell>
                            </TableRow>
                          ),
                        )
                      )}
                    </TableBody>
                  </Table>
                )}

                {activeTab === 9 && (
                  <Box p={3}>
                    <Paper elevation={3} sx={{ padding: 4 }} ref={reportRef}>
                      <Typography
                        variant="h4"
                        gutterBottom
                        align="center"
                        fontWeight="bold"
                      >
                        IPD Summary for {admissionDate}
                      </Typography>

                      {/* Patient Details */}
                      <div className="table-section">
                        <Section title="Patient Details">
                          <Box
                            sx={{
                              "& .MuiTableRow-root": {
                                backgroundColor: primaryColor,
                              },
                              "& .MuiTableCell-root": {
                                backgroundColor: "#fff",
                              },
                            }}
                          >
                            <BorderedTable
                              data={{
                                PatientId: patientInfo.id,
                                Name: patientInfo.name,
                                Age: patientInfo.age,
                                Gender: patientInfo.gender,
                                Contact: patientInfo.mobile,
                                Address: patientInfo.address,
                              }}
                            />
                          </Box>
                        </Section>
                      </div>
                      <div className="table-section">
                        <Section title="Admission Details">
                          <BorderedTable
                            data={{
                              AdmissionId: displayId(admission.id),
                              AdmissionDateTime: admissionDate,
                              PrescriptionId: displayId(
                                admissionPrescriptionId,
                              ),
                              Status: admission.status || "—",
                            }}
                          />
                        </Section>
                      </div>
                      {/* Assignments */}
                      {/* <Section title="Assignments">
                          <Table size="small">
                            <TableHead>
                              <TableRow sx={{ backgroundColor: primaryColor }}>
                                <TableCell sx={{ color: "#fff" }}>Department Name</TableCell>
                                <TableCell sx={{ color: "#fff" }}>Doctor Name</TableCell>
                                <TableCell sx={{ color: "#fff" }}>Staff Name</TableCell>
                                <TableCell sx={{ color: "#fff" }}>Ward</TableCell>
                                <TableCell sx={{ color: "#fff" }}>Bed</TableCell>
                                <TableCell sx={{ color: "#fff" }}>Assigned Date</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {(AssignmentList[admission.id] || []).map((assignment, idx) => (
                                <TableRow key={idx}>
                                  <TableCell>{assignment.departmentId}</TableCell>
                                  <TableCell>{assignment.doctorName}</TableCell>
                                  <TableCell>{assignment.nurseName}</TableCell>
                                  <TableCell>{assignment.wardName}</TableCell>
                                  <TableCell>{assignment.bedName}</TableCell>
                                  <TableCell>{formatAssignmentDate(assignment.admissionDate).format("DD MMM YYYY")}</TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </Section> */}

                      <div className="table-section">
                        <Section title="Assignments">
                          {(() => {
                            // Try both number and string keys to handle type mismatches
                            const assignment =
                              AssignmentList[admission.id] ||
                              AssignmentList[String(admission.id)] ||
                              AssignmentList[Number(admission.id)];
                            return assignment ? (
                              <Table size="small">
                                <TableHead>
                                  <TableRow
                                    sx={{ backgroundColor: primaryColor }}
                                  >
                                    <TableCell sx={{ color: "#fff" }}>
                                      Department Name
                                    </TableCell>
                                    <TableCell sx={{ color: "#fff" }}>
                                      Doctor Name
                                    </TableCell>
                                    <TableCell sx={{ color: "#fff" }}>
                                      Staff Name
                                    </TableCell>
                                    <TableCell sx={{ color: "#fff" }}>
                                      Ward
                                    </TableCell>
                                    <TableCell sx={{ color: "#fff" }}>
                                      Bed
                                    </TableCell>
                                    <TableCell sx={{ color: "#fff" }}>
                                      Assigned Date
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  <TableRow>
                                    <TableCell>
                                      {assignment?.departmentName || "-"}
                                    </TableCell>
                                    <TableCell>
                                      {assignment?.doctorName || "-"}
                                    </TableCell>
                                    <TableCell>
                                      {assignment?.nurseName || "-"}
                                    </TableCell>
                                    <TableCell>
                                      {assignment?.wardName || "-"}
                                    </TableCell>
                                    <TableCell>
                                      {assignment?.bedName || "-"}
                                    </TableCell>
                                    <TableCell>
                                      {assignment?.admissionDate
                                        ? formatAssignmentDate(
                                            assignment.admissionDate,
                                          ).format("DD MMM YYYY")
                                        : "-"}
                                    </TableCell>
                                  </TableRow>
                                </TableBody>
                              </Table>
                            ) : (
                              <Typography variant="body2" sx={{ px: 2, py: 1 }}>
                                No assignment found for this admission.
                              </Typography>
                            );
                          })()}
                        </Section>
                      </div>

                      {/* Treatments */}
                      <div className="table-section">
                        <Section title="Medicines">
                          <Table size="small">
                            <TableHead>
                              <TableRow sx={{ backgroundColor: primaryColor }}>
                                <TableCell sx={{ color: "#fff" }}>
                                  Treatment Type
                                </TableCell>
                                <TableCell sx={{ color: "#fff" }}>
                                  Medicine
                                </TableCell>
                                <TableCell sx={{ color: "#fff" }}>
                                  Dosage
                                </TableCell>
                                <TableCell sx={{ color: "#fff" }}>
                                  Performed By
                                </TableCell>
                                <TableCell sx={{ color: "#fff" }}>
                                  Remarks
                                </TableCell>
                                <TableCell sx={{ color: "#fff" }}>
                                  Performed At
                                </TableCell>
                                <TableCell sx={{ color: "#fff" }}>
                                  Performed Time
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {(() => {
                                // Try both number and string keys to handle type mismatches
                                const treatments =
                                  treatmentList[admission.id] ||
                                  treatmentList[String(admission.id)] ||
                                  treatmentList[Number(admission.id)] ||
                                  [];

                                if (treatments.length === 0) {
                                  return (
                                    <TableRow>
                                      <TableCell colSpan={7} align="center">
                                        No treatments found.
                                      </TableCell>
                                    </TableRow>
                                  );
                                }

                                // Get current staff lookup map for fallback enrichment
                                const currentStaffLookup =
                                  staffLookup instanceof Map
                                    ? staffLookup
                                    : new Map();

                                return treatments.map((treatment, idx) => {
                                  // Fallback enrichment if performedByName is missing
                                  let performedByName =
                                    treatment.performedByName;
                                  if (
                                    !performedByName &&
                                    treatment.performedBy &&
                                    currentStaffLookup.size > 0
                                  ) {
                                    const staffId = String(
                                      treatment.performedBy,
                                    );
                                    performedByName =
                                      currentStaffLookup.get(staffId) ||
                                      currentStaffLookup.get(
                                        Number(treatment.performedBy),
                                      );
                                  }

                                  return (
                                    <TableRow key={idx}>
                                      <TableCell>
                                        {treatment.treatmentType}
                                      </TableCell>
                                      <TableCell>
                                        <Typography fontWeight="bold">
                                          {treatment?.medicine
                                            ? treatment.medicine
                                                .toLowerCase()
                                                .replace(/\b\w/g, (c) =>
                                                  c.toUpperCase(),
                                                )
                                            : "-"}
                                        </Typography>
                                      </TableCell>
                                      <TableCell>{treatment.dosage}</TableCell>
                                      <TableCell>
                                        {performedByName ||
                                          treatment.performedBy ||
                                          "-"}
                                      </TableCell>
                                      <TableCell>{treatment.remarks}</TableCell>
                                      <TableCell>
                                        {dayjs(treatment.treatmentDate).format(
                                          "DD MMM YYYY",
                                        )}
                                      </TableCell>
                                      <TableCell>
                                        {formatTimeValue(
                                          treatment?.createdAt,
                                          treatment?.prescriptionDate,
                                          isDateTimeArray(
                                            treatment?.prescriptionDate,
                                          )
                                            ? treatment?.prescriptionDate
                                            : null,
                                          treatment?.updatedAt,
                                          treatment?.treatmentTime,
                                        )}
                                      </TableCell>
                                    </TableRow>
                                  );
                                });
                              })()}
                            </TableBody>
                          </Table>
                        </Section>
                      </div>

                      {/* Lab test Reports */}
                      <div className="table-section">
                      <Section title="Lab Tests">
                        <Table size="small">
                          <TableHead>
                            <TableRow sx={{ backgroundColor: primaryColor }}>
                              <TableCell sx={{ color: "#fff" }}>
                                Test Name
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Assigned By
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Assigned To
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Test Result
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Remarks
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Test Status
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Report Date
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {(() => {
                              const labTests = LabtTestList[admission.id] || [];

                              // Get current staff lookup map for enriching labName (fallback enrichment in display)
                              const currentStaffLookup =
                                staffLookup instanceof Map
                                  ? staffLookup
                                  : new Map();

                              // Enrich lab tests with labName from staff lookup (fallback if not enriched during fetch)
                              const enrichedLabTests = labTests.map((lab) => {
                                // Create a copy to avoid mutating the original
                                const enrichedLab = { ...lab };

                                // Enrich labName from labId (path desk staff ID) if not already enriched
                                if (
                                  enrichedLab.labId &&
                                  currentStaffLookup.size > 0
                                ) {
                                  const staffId = String(enrichedLab.labId);
                                  const staffName =
                                    currentStaffLookup.get(staffId) ||
                                    currentStaffLookup.get(
                                      Number(enrichedLab.labId),
                                    );
                                  if (
                                    staffName &&
                                    (!enrichedLab.labName ||
                                      enrichedLab.labName.trim() === "")
                                  ) {
                                    enrichedLab.labName = staffName;
                                  }
                                }

                                return enrichedLab;
                              });

                              // Deduplication: Use record ID first, then fall back to testName + testDate
                              const uniqueLabTestsMap = new Map();
                              const seenIds = new Set(); // Track seen record IDs to prevent exact duplicates

                              enrichedLabTests.forEach((lab) => {
                                // First, check if we've seen this exact record ID (exact duplicate)
                                if (lab.id !== null && lab.id !== undefined) {
                                  if (seenIds.has(lab.id)) {
                                    return; // Skip exact duplicate
                                  }
                                  seenIds.add(lab.id);
                                }

                                // Normalize test name (trim and lowercase for comparison)
                                const normalizedTestName = (lab.testName || "")
                                  .toString()
                                  .trim()
                                  .toLowerCase();
                                const testId = lab.testId || normalizedTestName;

                                // Normalize test date for consistent comparison
                                let normalizedDateStr = "";
                                if (lab.testDate) {
                                  if (Array.isArray(lab.testDate)) {
                                    normalizedDateStr = JSON.stringify(
                                      lab.testDate,
                                    );
                                  } else {
                                    // Convert to string and normalize
                                    normalizedDateStr = String(
                                      lab.testDate,
                                    ).trim();
                                  }
                                }

                                // Create unique key based on normalized testId/testName + normalized testDate
                                const uniqueKey = `${testId}-${normalizedDateStr}`;

                                // Check if we already have this test for this date
                                if (uniqueLabTestsMap.has(uniqueKey)) {
                                  const existingLab =
                                    uniqueLabTestsMap.get(uniqueKey);

                                  // Prefer the record with more complete information
                                  const existingScore =
                                    (existingLab.testResult ? 2 : 0) +
                                    (existingLab.labName ? 1 : 0) +
                                    (existingLab.id ? 1 : 0);
                                  const currentScore =
                                    (lab.testResult ? 2 : 0) +
                                    (lab.labName ? 1 : 0) +
                                    (lab.id ? 1 : 0);

                                  // Keep the one with more complete info, or the one with higher id if scores are equal
                                  if (
                                    currentScore > existingScore ||
                                    (currentScore === existingScore &&
                                      (lab.id || 0) > (existingLab.id || 0))
                                  ) {
                                    uniqueLabTestsMap.set(uniqueKey, lab);
                                  }
                                } else {
                                  // First occurrence of this testId + testDate combination
                                  uniqueLabTestsMap.set(uniqueKey, lab);
                                }
                              });

                              const uniqueLabTests = Array.from(
                                uniqueLabTestsMap.values(),
                              );

                              if (uniqueLabTests.length === 0) {
                                return (
                                  <TableRow>
                                    <TableCell colSpan={7} align="center">
                                      No Lab Tests Available.
                                    </TableCell>
                                  </TableRow>
                                );
                              }

                              return uniqueLabTests.map((lab, idx) => (
                                <TableRow
                                  key={
                                    lab.id ||
                                    `lab-summary-${idx}-${
                                      lab.resolvedTestName || lab.testName
                                    }-${lab.testDate}`
                                  }
                                >
                                  <TableCell>
                                    {lab.resolvedTestName ||
                                      lab.testName ||
                                      "N/A"}
                                  </TableCell>
                                  <TableCell>
                                    <Typography variant="body2">
                                      {AssignmentList[admission.id]
                                        ?.doctorName || "-"}
                                    </Typography>
                                  </TableCell>
                                  <TableCell>
                                    {lab.labName
                                      ? `Path: ${lab.labName
                                          .charAt(0)
                                          .toUpperCase()}${lab.labName.slice(
                                          1,
                                        )}`
                                      : ""}
                                  </TableCell>
                                  <TableCell>
                                    <Box
                                      sx={{
                                        maxWidth: 300,
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      {formatSubCategoryResults(lab.testResult)}
                                    </Box>
                                  </TableCell>
                                  <TableCell>
                                    <Box
                                      sx={{
                                        maxWidth: 200,
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      {extractRemarks(lab.testResult)}
                                    </Box>
                                  </TableCell>
                                  <TableCell>
                                    {lab.testStatus === "COMPLETED"
                                      ? "COMPLETE"
                                      : lab.testStatus}
                                  </TableCell>
                                  <TableCell>
                                    {lab.testDate
                                      ? formatLabTestDate(lab.testDate).format(
                                          "DD MMM YYYY",
                                        )
                                      : "-"}
                                  </TableCell>
                                </TableRow>
                              ));
                            })()}
                          </TableBody>
                        </Table>
                      </Section>
</div>


                      <div className="table-section">
                      <Section title="Operations">
                        <Table size="small">
                          <TableHead>
                            <TableRow sx={{ backgroundColor: primaryColor }}>
                              <TableCell sx={{ color: "#fff" }}>
                                Operation Name
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Operation Date
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Operation Time
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Operation Status
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Doctor/Surgeon
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Staff
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Pre Notes
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Post Notes
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {(operationList[admission.id] || []).length ===
                            0 ? (
                              <TableRow>
                                <TableCell colSpan={8} align="center">
                                  No Operation / Surgeries Record Available.
                                </TableCell>
                              </TableRow>
                            ) : (
                              (operationList[admission.id] || []).map(
                                (treatment, idx) => {
                                  // Format operation time
                                  let formattedTime = "-";
                                  if (treatment.operationTime) {
                                    if (
                                      Array.isArray(treatment.operationTime) &&
                                      treatment.operationTime.length >= 2
                                    ) {
                                      // Array format: [hour, minute]
                                      const hour =
                                        Number(treatment.operationTime[0]) || 0;
                                      const minute =
                                        Number(treatment.operationTime[1]) || 0;
                                      formattedTime = dayjs()
                                        .hour(hour)
                                        .minute(minute)
                                        .second(0)
                                        .format("hh:mm A");
                                    } else if (
                                      typeof treatment.operationTime ===
                                      "string"
                                    ) {
                                      // String format: "HH:mm"
                                      const [hour, minute] =
                                        treatment.operationTime
                                          .split(":")
                                          .map(Number);
                                      if (!isNaN(hour) && !isNaN(minute)) {
                                        formattedTime = dayjs()
                                          .hour(hour)
                                          .minute(minute)
                                          .second(0)
                                          .format("hh:mm A");
                                      }
                                    }
                                  }

                                  return (
                                    <TableRow key={idx}>
                                      <TableCell>
                                        {treatment.operationName || "-"}
                                      </TableCell>
                                      <TableCell>
                                        {treatment.operationDate
                                          ? Array.isArray(
                                              treatment.operationDate,
                                            )
                                            ? dayjs(
                                                new Date(
                                                  treatment.operationDate[0],
                                                  treatment.operationDate[1] -
                                                    1,
                                                  treatment.operationDate[2],
                                                ),
                                              ).format("DD MMM YYYY")
                                            : dayjs(
                                                treatment.operationDate,
                                              ).format("DD MMM YYYY")
                                          : "-"}
                                      </TableCell>
                                      <TableCell>{formattedTime}</TableCell>
                                      <TableCell>
                                        {treatment.operationStatus || "-"}
                                      </TableCell>
                                      <TableCell>
                                        {treatment.surgeonName || "-"}
                                      </TableCell>
                                      <TableCell>
                                        {treatment.nurseNames || "-"}
                                      </TableCell>
                                      <TableCell>
                                        {treatment.preOpNotes || "-"}
                                      </TableCell>
                                      <TableCell>
                                        {treatment.postOpNotes || "-"}
                                      </TableCell>
                                    </TableRow>
                                  );
                                },
                              )
                            )}
                          </TableBody>
                        </Table>
                      </Section>
</div>

                      <div className="table-section">
                      <Section title="Consumables">
                        <Table size="small">
                          <TableHead>
                            <TableRow sx={{ backgroundColor: primaryColor }}>
                              <TableCell sx={{ color: "#fff" }}>
                                Resource Name
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Quantity
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Used By
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Used on
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {(consumableList[admission.id] || []).length ===
                            0 ? (
                              <TableRow>
                                <TableCell colSpan={5} align="center">
                                  No Consumables found.
                                </TableCell>
                              </TableRow>
                            ) : (
                              (consumableList[admission.id] || []).map(
                                (consumable, idx) => {
                                  // Get current staff lookup map for fallback enrichment
                                  const currentStaffLookup =
                                    staffLookup instanceof Map
                                      ? staffLookup
                                      : new Map();

                                  // Fallback enrichment if usedByName is missing
                                  let usedByName = consumable.usedByName;
                                  if (
                                    !usedByName &&
                                    consumable.usedBy &&
                                    currentStaffLookup.size > 0
                                  ) {
                                    const staffId = String(consumable.usedBy);
                                    usedByName =
                                      currentStaffLookup.get(staffId) ||
                                      currentStaffLookup.get(
                                        Number(consumable.usedBy),
                                      );
                                  }
                                  if (!usedByName && consumable.usedBy) {
                                    usedByName = String(consumable.usedBy);
                                  }

                                  return (
                                    <TableRow key={idx}>
                                      <TableCell>
                                        {consumable.resourceName ||
                                          consumable.name ||
                                          consumable.itemName ||
                                          "-"}
                                      </TableCell>
                                      <TableCell>
                                        {consumable.quantity || "-"}
                                      </TableCell>
                                      <TableCell>{usedByName || "-"}</TableCell>
                                      <TableCell>
                                        {consumable.dateUsed
                                          ? Array.isArray(
                                              consumable.dateUsed,
                                            ) && consumable.dateUsed.length >= 3
                                            ? dayjs(
                                                new Date(
                                                  consumable.dateUsed[0],
                                                  consumable.dateUsed[1] - 1,
                                                  consumable.dateUsed[2],
                                                ),
                                              ).format("DD MMM YYYY")
                                            : dayjs(consumable.dateUsed).format(
                                                "DD MMM YYYY",
                                              )
                                          : "-"}
                                      </TableCell>
                                    </TableRow>
                                  );
                                },
                              )
                            )}
                          </TableBody>
                        </Table>
                      </Section>
                      </div>



                    <div className="table-section">

                      <Section title="Visit Records">
                        <Table size="small">
                          <TableHead>
                            <TableRow sx={{ backgroundColor: primaryColor }}>
                              <TableCell sx={{ color: "#fff" }}>
                                Visit Type
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Visited By
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Visited At
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Notes
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {(visitList[admission.id] || []).length === 0 ? (
                              <TableRow>
                                <TableCell colSpan={5} align="center">
                                  No Visit Record Available.
                                </TableCell>
                              </TableRow>
                            ) : (
                              (visitList[admission.id] || []).map(
                                (treatment, idx) => {
                                  // Get current staff lookup map for fallback enrichment
                                  const currentStaffLookup =
                                    staffLookup instanceof Map
                                      ? staffLookup
                                      : new Map();

                                  // Resolve visitedByName with fallback
                                  let visitedByName = treatment.visitedByName;
                                  if (!visitedByName && treatment.visitedBy) {
                                    if (treatment.visitType === "doctor") {
                                      // Try assignment first
                                      const assignment =
                                        AssignmentList[admission.id] ||
                                        AssignmentList[String(admission.id)] ||
                                        AssignmentList[Number(admission.id)];
                                      if (
                                        assignment &&
                                        assignment.doctorId ===
                                          treatment.visitedBy
                                      ) {
                                        visitedByName = assignment.doctorName;
                                      } else {
                                        visitedByName = String(
                                          treatment.visitedBy,
                                        );
                                      }
                                    } else {
                                      // For staff visits, use staff lookup
                                      if (currentStaffLookup.size > 0) {
                                        const staffId = String(
                                          treatment.visitedBy,
                                        );
                                        const staffName =
                                          currentStaffLookup.get(staffId) ||
                                          currentStaffLookup.get(
                                            Number(treatment.visitedBy),
                                          );
                                        if (staffName) {
                                          visitedByName = staffName;
                                        } else {
                                          visitedByName = String(
                                            treatment.visitedBy,
                                          );
                                        }
                                      } else {
                                        // Fallback: try assignment's nurse list
                                        const assignment =
                                          AssignmentList[admission.id] ||
                                          AssignmentList[
                                            String(admission.id)
                                          ] ||
                                          AssignmentList[Number(admission.id)];
                                        if (assignment && assignment.nurseId) {
                                          const ids = String(
                                            assignment.nurseId || "",
                                          )
                                            .split(",")
                                            .map((s) => s.trim());
                                          const names = String(
                                            assignment.nurseName || "",
                                          )
                                            .split(",")
                                            .map((s) => s.trim());
                                          const idx = ids.findIndex(
                                            (id) =>
                                              String(id) ===
                                              String(treatment.visitedBy),
                                          );
                                          visitedByName =
                                            idx >= 0
                                              ? names[idx] ||
                                                String(treatment.visitedBy)
                                              : String(treatment.visitedBy);
                                        } else {
                                          visitedByName = String(
                                            treatment.visitedBy,
                                          );
                                        }
                                      }
                                    }
                                  }

                                  return (
                                    <TableRow key={idx}>
                                      <TableCell>
                                        {treatment?.visitType
                                          ? treatment.visitType
                                              .toLowerCase()
                                              .replace(/\b\w/g, (c) =>
                                                c.toUpperCase(),
                                              )
                                          : "-"}
                                      </TableCell>
                                      <TableCell>
                                        {visitedByName || "-"}
                                      </TableCell>
                                      <TableCell>
                                        {Array.isArray(treatment.visitDate) &&
                                        treatment.visitDate.length > 0
                                          ? (() => {
                                              // Backend sends 1-indexed months, but JavaScript Date expects 0-indexed months
                                              const [
                                                year,
                                                month,
                                                day,
                                                ...rest
                                              ] = treatment.visitDate;
                                              return dayjs(
                                                new Date(
                                                  year,
                                                  month - 1,
                                                  day,
                                                  ...rest,
                                                ),
                                              ).format("DD MMM YYYY");
                                            })()
                                          : treatment.visitDate
                                          ? dayjs(treatment.visitDate).format(
                                              "DD MMM YYYY",
                                            )
                                          : "-"}
                                      </TableCell>
                                      <TableCell>
                                        {treatment.notes || "-"}
                                      </TableCell>
                                    </TableRow>
                                  );
                                },
                              )
                            )}
                          </TableBody>
                        </Table>
                      </Section>
</div>


<div className="table-section">

                      <Section title="Discharge Details">
                        <Table size="small">
                          <TableHead>
                            <TableRow sx={{ backgroundColor: primaryColor }}>
                              <TableCell sx={{ color: "#fff" }}>
                                Discharge Date
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Discharge Time
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Discharge Type
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Final Diagnose
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Follow up Advice
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Condition On Discharge
                              </TableCell>
                              <TableCell sx={{ color: "#fff" }}>
                                Remarks
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {(dischargeList[admission.id] || []).length ===
                            0 ? (
                              <TableRow>
                                <TableCell colSpan={7} align="center">
                                  No Discharge Record Available.
                                </TableCell>
                              </TableRow>
                            ) : (
                              (dischargeList[admission.id] || []).map(
                                (discharge, idx) => (
                                  <TableRow key={idx}>
                                    <TableCell>
                                      {Array.isArray(discharge.dischargeDate) &&
                                      discharge.dischargeDate.length > 0
                                        ? dayjs(
                                            new Date(
                                              ...discharge.dischargeDate,
                                            ),
                                          ).format("DD MMM YYYY")
                                        : discharge.dischargeDate
                                        ? dayjs(discharge.dischargeDate).format(
                                            "DD MMM YYYY",
                                          )
                                        : "-"}
                                    </TableCell>
                                    <TableCell>
                                      {Array.isArray(discharge.dischargeTime) &&
                                      discharge.dischargeTime.length >= 2
                                        ? dayjs(
                                            new Date(
                                              2025,
                                              0,
                                              1,
                                              discharge.dischargeTime[0],
                                              discharge.dischargeTime[1],
                                            ),
                                          ).format("hh:mm A")
                                        : "-"}
                                    </TableCell>
                                    <TableCell>
                                      {discharge.dischargeType ||
                                        discharge.dischargeType}
                                    </TableCell>
                                    <TableCell>
                                      {discharge.finalDiagnose ||
                                        discharge.finalDiagnose}
                                    </TableCell>
                                    <TableCell>
                                      {discharge.followUpAdvice ||
                                        discharge.followUpAdvice}
                                    </TableCell>
                                    <TableCell>
                                      {discharge.conditionOnDischarge ||
                                        discharge.conditionOnDischarge}
                                    </TableCell>
                                    <TableCell>
                                      {discharge.remarks || discharge.remarks}
                                    </TableCell>
                                  </TableRow>
                                ),
                              )
                            )}
                          </TableBody>
                        </Table>
                      </Section>
                      </div>
                    </Paper>

                    {/* Print & Export Buttons */}
                    <Box display="flex" justifyContent="center" gap={2} mt={4}>
                      <Button
                        variant="outlined"
                        color="primary"
                        onClick={() => handlePrint(admission)}
                      >
                        Print Summary
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => exportToPDF(admission)}
                      >
                        Export to PDF
                      </Button>
                    </Box>
                  </Box>
                )}
              </Paper>
            </Box>
          </Box>
        );
      })}
      <PatientAssignmentModal
        open={open_assignment_modal}
        onClose={async () => {
          setOpenAsignmentModal(false);
          setSelectedAdmissionId(null);
          setSelectedPatientId(null);
          setRefreshFlag((prev) => !prev);
        }}
        admissionId={selectedAdmissionId}
        patientId={selectedPatientId}
      />
      <PatientTreatmentModal
        open={open_treatment_modal}
        onClose={async () => {
          setOpenTreatmentModal(false);
          setSelectedAdmissionId(null);
          setSelectedPatientId(null);
          setRefreshFlag((prev) => !prev);
        }}
        admissionId={selectedAdmissionId}
        patientId={selectedPatientId}
      />
      <PatientConsumableModal
        open={open_consumable_modal}
        onClose={async () => {
          setOpenConsumableModal(false);
          setSelectedAdmissionId(null);
          setSelectedPatientId(null);
          setRefreshFlag((prev) => !prev);
        }}
        admissionId={selectedAdmissionId}
        patientId={selectedPatientId}
      />
      <PatientConsumableModal
        open={open_consumable_modal}
        onClose={async () => {
          setOpenConsumableModal(false);
          setSelectedAdmissionId(null);
          setSelectedPatientId(null);
          setRefreshFlag((prev) => !prev);
        }}
        admissionId={selectedAdmissionId}
        patientId={selectedPatientId}
      />
      <DoctorVisitsModal
        open={open_doctorVisit_modal}
        onClose={async () => {
          setOpenDoctorvisitModal(false);
          setSelectedAdmissionId(null);
          setSelectedPatientId(null);
        }}
        admissionId={selectedAdmissionId}
        patientId={selectedPatientId}
      />
      <PatientOperationModal
        open={open_operation_modal}
        onClose={async () => {
          setOpenOperationModal(false);
          setSelectedAdmissionId(null);
          setSelectedPatientId(null);
          setRefreshFlag((prev) => !prev);
        }}
        admissionId={selectedAdmissionId}
        patientId={selectedPatientId}
      />
      <PatientDischargeModal
        open={open_discharge_modal}
        onClose={async () => {
          setOpenDischargeModal(false);
          setSelectedAdmissionId(null);
          setSelectedPatientId(null);
          setRefreshFlag((prev) => !prev);
        }}
        admissionId={selectedAdmissionId}
        patientId={selectedPatientId}
        refreshData={() => setRefreshFlag((prev) => !prev)}
      />
      <IpdInvoice
        open={open_doctor_modal}
        onClose={() => {
          setOpenDoctorModal(false);
        }}
        admissionId={selectedAdmissionId}
      />

      {isPharmacyAdmin && (
        <IpdIssueMedicineModal
          open={openIssueMedicineModal}
          onClose={handleIssueMedicineClose}
          treatment={selectedIssueTreatment}
          onSubmit={handleIssueMedicineSubmit}
          patientId={patientInfo.id}
          patientName={patientInfo?.name}
          doctorName={
            selectedIssueTreatment?.admissionId
              ? AssignmentList[selectedIssueTreatment.admissionId]?.doctorName ||
                AssignmentList[String(selectedIssueTreatment.admissionId)]?.doctorName ||
                null
              : null
          }
          doctorId={
            selectedIssueTreatment?.admissionId
              ? AssignmentList[selectedIssueTreatment.admissionId]?.doctorId ||
                AssignmentList[selectedIssueTreatment.admissionId]?.doctor_id ||
                AssignmentList[String(selectedIssueTreatment.admissionId)]?.doctorId ||
                null
              : null
          }
          admissionId={selectedIssueTreatment?.admissionId || null}
          prescriptionId={
            selectedIssueTreatment?.prescriptionId ||
            selectedIssueTreatment?.prescription_id ||
            selectedIssueTreatment?.ipdPrescriptionId ||
            selectedIssueTreatment?.ipd_prescription_id ||
            null
          }
          departmentId={
            selectedIssueTreatment?.admissionId
              ? AssignmentList[selectedIssueTreatment.admissionId]?.departmentId ||
                AssignmentList[selectedIssueTreatment.admissionId]?.department_id ||
                AssignmentList[String(selectedIssueTreatment.admissionId)]?.departmentId ||
                null
              : null
          }
        />
      )}

      {/* Medicine Request Modal */}
      <MedicineRequestModal
        open={openRequestModal}
        onClose={handleRequestModalClose}
        treatment={selectedRequestTreatment}
        onSubmit={handleRequestSubmit}
        patientId={patientInfo.id}
        admissionId={selectedRequestTreatment?.admissionId}
      />

      {/* Medicine Return Modal */}
      <MedicineReturnModal
        open={openReturnModal}
        onClose={handleReturnModalClose}
        treatment={selectedReturnTreatment}
        onSubmit={handleReturnSubmit}
        patientId={patientInfo.id}
        medicineRequest={selectedReturnTreatment?.medicineRequest}
      />

      {/* Patient Medicine Administration Modal */}
      <PatientMedicineAdministrationModal
        open={openAdministrationModal}
        onClose={handleAdministrationModalClose}
        patientInventory={selectedInventoryItem}
        onSubmit={handleAdministrationSubmit}
        patientId={patientInfo.id}
        admissionId={selectedInventoryItem?.admissionId}
      />
    </Box>
  );
};
export default PatientTimeline;
